<template>
  <div class="map">
    <!-- <span style="border: 1px solid gray;display: inline-block; vertical-align: top; width:220px;"> -->
      <div class="mapHead">
        <div style="margin-right:50px" v-if='elemapInfo.title'> <span>标题：</span> {{elemapInfo.title}}</div>
        <div> <span>操作类别：</span> {{makeMapTitle}}</div>
        <div class="head-select" v-if="type==2 || type==3 ||type==6">
          <span>切换模拟图：</span>
          <el-cascader
            placeholder="请选择模拟图"
            :show-all-levels="false"
            v-model="title"
            :options="titles"
            @change="changeMap"></el-cascader>
          <div style="margin-left:50px" v-if="type==2">
            <el-button size="medium" @click="endSimulate">结束预演</el-button>
          </div>
        </div>
        <div class="buttonGroup"  v-if="type!==2">
          <el-button id="saveModel" size="medium" @click="mySave" v-if="type!==6">保存</el-button>
          <el-button v-else @click="goBackMaplist">返回</el-button>
          <!-- <el-button size="medium" @click="download()">下载图片</el-button> -->
       </div>
      
      </div>
    <div id="paletteDraggable" class="palettedraggable" v-if="isPreview">
      <div id="paletteDraggableHandle" class="handle">元件</div>
      <div id="paletteContainer" style="height:calc(100% - 16px);;overflow:auto">
      
         <span style="display: inline-block; vertical-align: top; width:100%;background:#fff">
          <div id="accordion">
            <h4 @click="collapse(1)">阀门<i :class="item1==false ?'el-icon-caret-right':'el-icon-caret-bottom'"></i></h4>
            <div :style="{height:paletteHeight}">
              <div id="myPaletteDiv"  :style="{height:paletteHeight}"></div>
            </div>
            <h4 @click="collapse(3)">开关<i :class="item3==false ?'el-icon-caret-right':'el-icon-caret-bottom'"></i></h4>
            <div :style="{height:paletteHeight}">
              <div id="onoffPalette"  :style="{height:paletteHeight}"></div>
            </div>
            <h4 @click="collapse(2)">静态元件<i :class="item2==false ?'el-icon-caret-right':'el-icon-caret-bottom'"></i></h4>
            <div :style="{height:paletteHeight}">
              <div id="myPaletteDiv1" :style="{height:paletteHeight}"></div>
            </div>
            
          </div>
        </span>
      </div>
    </div>
    <!-- <div id="myPaletteDiv" style="height: 600px;"></div> -->
    <div class="diagram" :style="{ width:isPreview?'calc(100% - 300px)':'100%',height:diagramHeight }" >

      <div id="myDiagramDiv" style="height:100%" @keyup.delete="deleteNode"></div>

      <div
        id="infoDraggable"
        class="draggable"
        style="display: inline-block; vertical-align: top; padding: 3px; top: 0px; left: 0px;max-height:calc(100% - 10px)"
        v-show="infoshow"
      >
        
        <div style="text-align:left">
          <div id="infoDraggableHandle" class="handle">信息面板</div>
          <div id="myInfo"></div>
            <div class="titleStyle" v-if="isshowTitle">
              <span class="logicLabel">简称</span>
              <el-input
                placeholder="请输入内容"
                v-model="infoTitle"
                clearable
                type="textarea"
                autosize
                :disabled="!titleshow">
                <!-- @input="titleInput"> -->
                <!-- :disabled="!titleshow"> -->
              </el-input>
            </div>

            <div class="titleStyle" style="margin-top:8px" v-if="isshowTitle">
              <span class="logicLabel">全称</span>
              <el-input
                placeholder="请输入内容"
                v-model="fullName"
                clearable
                  type="textarea"
                   autosize
                :disabled="!titleshow">
              </el-input>
            </div>
            <div style="text-align:left;margin:8px 0" v-if="operate">
              <span class="logicLabel">状态</span>
             
              <div v-if="moreChoice" style="display:inline-block" class="raidoInput">
                <el-radio v-model="currentStatus" label="1">
                  <el-input v-model="currentChoice1"></el-input>
                </el-radio>
                <el-radio v-model="currentStatus" label="0">
                  <el-input v-model="currentChoice0" ></el-input>
                </el-radio>
                <el-radio v-model="currentStatus" label="2">
                  <el-input v-model="currentChoice2"></el-input>
                </el-radio>
              </div>
              <div  style="display:inline-block" class="raidoInput" >
                <el-radio v-model="currentStatus" label="1" v-if="!moreChoice" >
                  <el-input v-model="stateon"></el-input>
                </el-radio>
                <el-select style="max-width:100px" v-model="groundValue" clearable filterable placeholder="请选择" v-if="isGround">
                  <el-option
                    v-for="item in groundOptions"
                    :key="item.id"
                    :label="item.linename"
                    :value="item.linename">
                  </el-option>
                </el-select>
                <el-radio v-model="currentStatus" label="0" v-if="!moreChoice">
                  <!-- <el-input v-model="stateoff" @input="radioInput(4)"></el-input> -->
                  <el-input v-model="stateoff" ></el-input>
                </el-radio>
              </div>

            </div>

            <div class="describle" v-if="describeShow">
               <span class="logicLabel">描述</span>
               <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5}"
                placeholder="请输入内容"
                v-model="describeText"
                width="calc(100% - 80px)"
                :disabled="describeDisable">
              </el-input>
            </div>

            <div class="imgupload" v-if="describeShow">
              <span class="logicLabel">图片</span>
              <el-upload
                :class="{hide:hideUpload}"
                action=""
                list-type="picture-card"
                ref="upload"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :http-request="fileupload"
                multiple
                :file-list="fileList"
                :auto-upload="false"
                
                :style="{ 'max-height':uploadHeight,'padding':'5px','overflow':'auto' }"
                :disabled="uploadDisable"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>

            <div style="text-align:left;margin:8px 0" v-if="standardStatus">
              <span class="logicLabel">标准状态</span>
             
              <div v-if="moreChoice" style="display:inline-block">
                <el-radio v-model="state" label="1">{{currentChoice1}}</el-radio>
                <el-radio v-model="state" label="0">{{currentChoice0}}</el-radio>
                <el-radio v-model="state" label="2">{{currentChoice2}}</el-radio>
              </div>
              <div v-if="!moreChoice" style="display:inline-block" >
                <el-radio v-model="state" label="1">{{stateon}}</el-radio>
                <el-radio v-model="state" label="0">{{stateoff}}</el-radio>
              </div>
            </div>
          <div class="logic" v-show="clickDiagramnode">
            <div style="margin:8px 0">
             <span class="logicLabel" v-if="moreChoice">{{currentChoice1}}逻辑</span>
             <span class="logicLabel" v-else>{{stateon}}逻辑</span>
              <el-cascader
                id="cascader"
                ref="cascader"
                v-model="logicValue"
                :options="infoOptions"
                :props="props"
                clearable
                filterable
                @change="change"
              ></el-cascader>
             </div>
            <div>
              <span class="logicLabel" v-if="moreChoice">{{currentChoice0}}逻辑</span>
              <span class="logicLabel" v-else>{{stateoff}}逻辑</span>
              <el-cascader
                id="cascaderoff"
                ref="cascaderoff"
                v-model="logicValueOff"
                :options="offinfoOptions"
                :props="props"
                clearable
                filterable
                @change="changeOff"
              ></el-cascader>
            </div>
            <div v-if="moreChoice" style="margin:8px 0">
              <span class="logicLabel">{{currentChoice2}}逻辑</span>
              <el-cascader
                id="cascaderChoice2"
                ref="cascaderChoice2"
                v-model="logicValueChoice2"
                :options="choice2infoOptions"
                :props="props"
                clearable
                filterable
                @change="changeChoice2"
              ></el-cascader>
            </div>
            <div style="text-align:left;margin:0 5px">
              <el-button type="primary" size="small" round @click="addLogic" style="margin:8px  0">添加逻辑</el-button>
              <el-button type="info" size="small" round @click="clearallLogic" style="margin:8px  0">清空逻辑</el-button>
            </div>
            <div class="showlogic">
              <h4 v-if="moreChoice">{{currentChoice1}}逻辑:</h4>
              <h4 v-else>{{stateon}}逻辑:</h4>
                  <el-tag
                    v-for="(item,index) in onlogic"
                    :key="'on1'+index"
                    closable
                    :disable-transitions="false"
                     @close="delLogicon(item,index)"
                    >
                    {{index+1}}.<span v-for="(item1,index1) in item"
                    :key="'on'+index1">{{item1.value}};</span>
                  </el-tag>
               
              <h4 v-if="moreChoice">{{currentChoice0}}逻辑:</h4>
              <h4 v-else>{{stateoff}}逻辑:</h4>
              <el-tag
                    v-for="(offitem,offindex) in offlogic"
                    :key="'off1'+offindex"
                    closable
                    :disable-transitions="false"
                     @close="delLogicoff(offitem,offindex)"
                    >
                    {{offindex+1}}.<span v-for="(offitem1,offindex1) in offitem"
                    :key="'off'+offindex1">{{offitem1.value}};</span>
                  </el-tag>
                <div v-if="moreChoice">
                    <h4 >{{currentChoice2}}逻辑:</h4>
                    <el-tag
                          v-for="(c2item,c2index) in choice2logic"
                          :key="'c2'+c2index"
                          closable
                          :disable-transitions="false"
                          @close="delLogic2(c2item,c2index)"
                          >
                          {{c2index+1}}.<span v-for="(c2item1,c2index1) in c2item"
                          :key="'c2item'+c2index1">{{c2item1.value}};</span>
                    </el-tag>
                  </div>
            </div>

          </div>
          <div  class="setImgAttr" v-show="myType==2 && (type==1 || type==undefined)">
            <div>
              <div class="imgTitle">设置宽</div>
              <div> <el-input v-model="imgWidth" placeholder="请输入内容"></el-input> </div>
            </div>
            <div>
              <div class="imgTitle">设置高</div>
              <div> <el-input v-model="imgHeight" placeholder="请输入内容"></el-input> </div>
            </div>
          </div>
          <!-- <div class="setImgAttr">
            <div>
              <div class="imgTitle">设置X</div>
              <div> <el-input v-model="X" placeholder="请输入内容"></el-input> </div>
            </div>
            <div>
              <div class="imgTitle">设置Y</div>
              <div> <el-input v-model="Y" placeholder="请输入内容"></el-input> </div>
            </div>
          </div> -->
          <div  class="promptBtn" v-if="!isaddLogic"> 
            <el-button size="medium" type="primary" @click="defineChange">确定</el-button>
            <el-button size="medium" @click="cancel">取消</el-button>
          </div>
         
        </div>
      </div>

    </div>
     
    <!-- <textarea
      id="mySavedModel"
      style="width:100%;height:200px;border:1px solid #000"
      v-model="modelData"
    ></textarea> 

    <div style="display:flex;min-height:200px;">
      <div style="width:100%;height:100px;border:1px solid blue">
        <div
          v-for="(item,index) in checkList"
          :key="index"
          style="color:blue;border:1px solid black;"
        >{{item}}</div>
      </div>
    </div> -->
    <div class="addMapClass">
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogFormVisible"
        width='500px'
        @close="resetForm('elemapForm')">
        <el-form :model="elemapInfo" :rules="rules" ref="elemapForm">
          <el-form-item label="模拟图标题" :label-width="formLabelWidth" prop="title">
            <el-input v-model="elemapInfo.title" placeholder="请输入模拟图标题"></el-input>
          </el-form-item>
          <el-form-item label="模拟图类型" :label-width="formLabelWidth" prop="title">
              <el-select v-model="mapType" filterable placeholder="请选择" clearable >
                  <el-option
                    v-for="item in mapTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false,resetForm('elemapForm')">取 消</el-button>
          <el-button type="primary" @click="save('elemapForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 逻辑操作错误弹框 -->
    <el-dialog
      title="操作的前提条件(需满足至少一项)"
      :visible.sync="operationDialogVisible"
      min-width="500px"
      @close="dialogClose">
      
      <!-- <ol >
        <li v-for="(operItem,operIndex) in operRecord" :key="operIndex">
            <span v-for="(operItem1,operIndex1) in operItem" :key="operIndex1">{{operItem1.value}} ; </span>
        </li>
      </ol> -->
      
        <el-table
        :data="operRecord"
        :span-method="objectSpanMethod"
        border
        max-height="500px"
        style="overflow:auto"
        :row-class-name="tableRowClassName">
        <!-- <el-table-column type="index" width="50" label="条件"></el-table-column> -->
        <el-table-column prop="logicSign" label="条件" width="50" :formatter="logicSignformat" align='center'></el-table-column>
        <el-table-column prop="mapType" label="模拟图类" align='center'></el-table-column>
        <el-table-column prop="mapName" label="模拟图名" align='center'></el-table-column>
        <el-table-column prop="mapEle" label="元件名" align='center'></el-table-column>
        <el-table-column prop="eleStatus" label="状态" align='center'></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 模拟预演标题 -->
      <el-dialog
        title="提示"
        :visible.sync="myDialogVisible"
        width="500px">
        <div>是否结束模拟预演？</div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="myDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveTitle">确 定</el-button>
        </div>
      </el-dialog>
       <!-- 查看预览图弹出框 -->
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt />
      </el-dialog>
  </div>
</template>

<script>
import png1 from "../assets/1.png";
import png2 from "../assets/2.png";
import png3 from "../assets/3.png";
import png4 from "../assets/4.png";
import png5 from "../assets/5.png";
import png6 from "../assets/6.png";
import png7 from "../assets/7.png";
import png8 from "../assets/8.png";
import png9 from "../assets/9.png";
import png10 from "../assets/10.png";
import png11 from "../assets/11.png";
import png12 from "../assets/12.png";
import png13 from "../assets/13.png";
import png14 from "../assets/14.png";
import png15 from "../assets/15.png";
import png16 from "../assets/16.png";
import png17 from "../assets/17.png";
import png18 from "../assets/18.png";
import png19 from "../assets/19.png";
import png20 from "../assets/20.png";
import png21 from "../assets/21.png";
import png22 from "../assets/22.png";
import png23 from "../assets/23.png";
import png24 from "../assets/24.png";
import png25 from "../assets/25.png";
import png26 from "../assets/26.png";
import png33 from "../assets/33.png";
import png34 from "../assets/34.png";

import png44 from "../assets/44.png";
import png45 from "../assets/45.png";
import png46 from "../assets/46.png";
import png47 from "../assets/47.png";
import png48 from "../assets/48.png";
import png49 from "../assets/49.png";
import png50 from "../assets/50.png";
import png51 from "../assets/51.png";
import png52 from "../assets/52.png";
import png53 from "../assets/53.png";
import png54 from "../assets/54.png";
import png55 from "../assets/55.png";
import png56 from "../assets/56.png";
//import { Binding } from '../../static/js/go-debug'
let go = window.go;
let $ = go.GraphObject.make;

export default {
  name: "",
  data() {
    return {
      mapTypes:[
      ],
      hideUpload: false,
      previewimgurl:'',
      fileList: [],
      dialogImageUrl:'',
      dialogVisible: false,
      mapType:'',
      makeMapTitle:"新增模拟图",
      selectmapid:'',
      mapList:[],
      allmapInfolist:[],
      infoTitle:'',
      fullName:'',
      myDialogVisible:false,
      mapTitle:"",
      paletteHeight:'',
      diagramHeight:'',
      uploadHeight:'',
      state:'1',
      currentStatus:'',
      isPreview:true,
      dialogTitle:'创建模拟图',
      activeName:'2',
      props: { multiple: true },
      logicValue: [],
      logicValueOff:[],
      logicValueChoice2:[],
      logicArr: [],
      logicData: [],
      infoOptions: [],
      offinfoOptions:[],
      choice2infoOptions:[],
      groundValue:'',
      groundOptions:[],
      wrongIndex:[],
      diagram: null,
      operationDialogVisible:false,
      onchange:false,
      offchange:false,
      choice2change:false,
      isGround:false,//是否为接地桩
      infoshow:false,//信息面板的显示
      describeShow:false,//描述是否显示
      logicSignon:0,//逻辑标志
      logicSignoff:0,
      logicSignchoice2:0,
      mapid: "",
      describeText:'',//描述字段
      elemapInfo: {
        title: "",
        nodedata: [],
        linkdata: [],
        userid: "",
        reviserid: "",
        userName:""
      },
      modelData: {
        class: "go.GraphLinksModel",
        linkFromPortIdProperty: "fromPort",
        linkToPortIdProperty: "toPort",
        nodeDataArray: [],
        linkDataArray: []
      },
      dialogFormVisible: false,
      formLabelWidth: "100px",
      circleText: "M",
      checkList: [],
      operRecord:[],
      parentKey: "",
      isBind: false,
      isaddDescribe:false,//是否为添加描述
      isshowTitle:true,//标题是否显示
      titleshow:true,//标题是否可编辑
      operate:true,//操作状态
      standardStatus:false,//标准状态
      clickDiagramnode: false,//逻辑面板的显示
      isaddLogic:false,//是否为添加逻辑
      describeDisable:false,//描述是否禁用
      uploadDisable:false,//上传是否禁用
      white: "white", // 0 or false
      gray: "#A0A0A0", // 1 or true
      black: "#000000",
      clickn: "",//左键点击
      rightclick:'',//右键点击
      edittext:'编辑文本',
      color:"#ff0000",//开
      offcolor:"#00ff00",//关
      oiltext:"压油槽",
      angle:0,
      switchangle:300,
      height:20,
      type: 1,
      item1:true,
      item2:false,
      item3:false,
      allowDelete:true,
      allowMove:true,
      allowRotate:true,
      allowLink:true,
      allowResize:true,
      linkMove:true,
      option1:'主用',
      option0:'切除',
      option2:'备用',
      top1:'1',
      top0:'退出',
      top2:'2',
      moreChoice:false,//多种情况
      currentChoice1:'',
      currentChoice0:'',
      currentChoice2:'',
      usertype:'',
      valveon:'开启',
      valveoff:'关闭',
      stateon:'合位',
      stateoff:'分位',
      draweron:'工作位置',
      draweroff:'检修位置',
      groundon:'接地',
      groundoff:'未接地',
      onlogic:[],
      offlogic:[],
      choice2logic:[],
      rules: {
        title: [
          { required: true, message: "请输入模拟图标题", trigger: "blur" }
        ]
      },
      myData:[],
      png1: png1,
      png2: png2,
      png3: png3,
      png4: png4,
      png5: png5,
      png6: png6,
      png7: png7,
      png8: png8,
      png9: png9,
      png10: png10,
      png11: png11,
      png12: png12,
      png13: png13,
      png14: png14,
      png15: png15,
      png16: png16,
      png17: png17,
      png18: png18,
      png19: png19,
      png20: png20,
      png21: png21,
      png22: png22,
      png23: png23,
      png24: png24,
      png25: png25,
      png26: png26,
      png33: png33,
      png34: png34,

      png44: png44,
      png45: png45,
      png46: png46,
      png47: png47,
      png48: png48,
      png49: png49,
      png50: png50,
      png51: png51,
      png52: png52,
      png53: png53,
      png54: png54,
      png55: png55,
      png56: png56,
      simulateContent:[],
      simulateInfo:{
      },
      titles:[],//模拟图数组
      title:'',//模拟图
      allMapInfo:[],
      lineData:[],//接地桩的接线信息
      allMapInfoBySimulate:[],//所有的模拟图数据，模拟预演用于校准
      myHeight:30,
      myWidth:60,
      myType:'',//设备的type
      imgWidth:'',
      imgHeight:'',
      X:'',
      Y:'',
      loc:"",
    };
  },
  mounted() {
    this.paletteHeight=window.innerHeight-200+'px';
    this.diagramHeight=window.innerHeight-60+'px';
    this.uploadHeight=window.innerHeight-287+'px';
    window.onresize = function(){
      this.paletteHeight=window.innerHeight-200+'px';
      this.diagramHeight=window.innerHeight-60+'px';
      this.uploadHeight=window.innerHeight-287+'px';
    }
    this.usertype=JSON.parse(sessionStorage.getItem('userinfo')).type
    if (this.$route.params) {
      // ////console.log("页面传参",this.$route.params)
      this.mapid = this.$route.params.id;
      this.selectmapid = this.$route.params.id;
      this.type = this.$route.params.type;
      if(this.type==1){
        this.dialogTitle="修改模拟图";
        this.makeMapTitle="修改模拟图"
      }else if(this.type==2||this.type==3||this.type==4 || this.type==6){
        this.isPreview=false
        this.allowDelete=false
        this.allowMove=false
        this.allowRotate=false
        this.allowLink=false
        this.allowResize=false
        this.linkMove=false
        if(this.type==2){
          this.simulateInfo.title=this.$route.params.title;
          this.simulateInfo.userName=this.$route.params.userName;
          this.simulateInfo.guarder=this.$route.params.guarder;
          this.simulateInfo.createtime=this.$route.params.createtime;
          this.simulateInfo.mapid=this.$route.params.id;
          this.makeMapTitle="模拟图预演";
          this.getMapBySimulate()
        }
        if(this.type==3){
          this.makeMapTitle="操作模拟图";
          
        }
        if(this.type==4){
          this.makeMapTitle="添加逻辑";
          
        }
        if(this.type==6){
          this.makeMapTitle="查看模拟图"
        }

        // ////console.log("simulateInfo", this.simulateInfo)
      }
    }
    this.getLine()
    this.getmapElement()
    
   
    if (sessionStorage.getItem("userinfo")) {
      //获取登录用户信息
      this.elemapInfo.userid = JSON.parse(
        sessionStorage.getItem("userinfo")
      ).id;
      this.elemapInfo.userName = JSON.parse(
        sessionStorage.getItem("userinfo")
      ).name;
    }
    var white = "white"; // 0 or false
    var gray = "#A0A0A0"; // 1 or true
    var black = "#000000";
    let _this = this;
    var drawItems=[{ height:110,width:40,source:_this.png33 }]
    var draw2Items=[{ height:100, width:40, source:_this.png34 }]
    
    let myDiagram = $(go.Diagram, "myDiagramDiv", {
      "initialAutoScale": go.Diagram.UniformToFill,
      "toolManager.mouseWheelBehavior": go.ToolManager.WheelZoom,
      "draggingTool.isGridSnapEnabled": true, // dragged nodes will snap to a grid of 10x10 cells
      "undoManager.isEnabled": true,
      "allowDelete":_this.allowDelete,//允许删除
      "allowMove":_this.allowMove,  //允许移动
      "allowRotate":_this.allowRotate,
      "allowLink":_this.allowLink,
      "allowResize":_this.allowResize
    },
    );
    //图片 集中处理
    myDiagram.nodeTemplate =
    $(go.Node, "Auto",this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
        new go.Binding("itemArray", "items"),
         new go.Binding("angle","angle").makeTwoWay(),
        {
          itemTemplate:
            $(go.Panel,'Spot',
               $(
                go.Picture,
                this.imgStyle(),
                new go.Binding("source", "source").makeTwoWay(),
                new go.Binding("width", "width").makeTwoWay(),
                new go.Binding("height", "height").makeTwoWay(),
               
              ),
               $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
                  portId: "R",
                  alignment: new go.Spot(1, 0.5)
                }),
                $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
                  portId: "L",
                  alignment: new go.Spot(0, 0.5)
                }),
                $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
                  portId: "T",
                  alignment: new go.Spot(0.5, 0)
                }),
                $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
                  portId: "B",
                  alignment: new go.Spot(0.5, 1)
                }),
            ),
        }),

    myDiagram.addDiagramListener("ChangedSelection", function(diagramEvent) {
      var idrag = document.getElementById("infoDraggable");
      // idrag.style.width = "";
      // idrag.style.height = "";
    });

    myDiagram.addDiagramListener("BackgroundSingleClicked", function(e) {
      _this.infoshow=false
      jQuery(".el-select-dropdown").hide()
      jQuery(".el-cascader__dropdown").hide()
     
    });
    myDiagram.addDiagramListener("Modified", function(e) {
      // var button = document.getElementById("saveModel");
      // if (button) button.disabled = !myDiagram.isModified;

      // var idx = document.title.indexOf("*");
      // if (myDiagram.isModified) {
      //   if (idx < 0) document.title += "*";
      // } else {
      //   if (idx >= 0) document.title = document.title.substr(0, idx);
      // }
    });

    myDiagram.linkTemplate = $(
      go.Link,
      {
        routing: go.Link.AvoidsNodes,//绕过节点
        curve: go.Link.JumpOver,//线跳过
        corner: 0,
        relinkableFrom: true,
        relinkableTo: true,
        selectionAdorned: false, // Links are not adorned when selected so that their color remains visible.
        reshapable: _this.linkMove,//移动线
        shadowOffset: new go.Point(0, 0),
        shadowBlur: 5,
        shadowColor: "blue",
        click:this.linkClick
      },
      new go.Binding("points").makeTwoWay(),
      new go.Binding("isShadowed", "isSelected").ofObject(),
      $(go.Shape, { name: "SHAPE", strokeWidth: 2, stroke: gray })

      // $(go.Shape, { isPanelMain: true, stroke: "black", strokeWidth: 7 }),
      // $(go.Shape, { isPanelMain: true, stroke: "gray", strokeWidth: 5 }),
      // $(go.Shape, { isPanelMain: true, stroke: "white", strokeWidth: 3, name: "PIPE", strokeDashArray: [10, 10] }),
    );

    // define templates for each type of node
    var onoff  = $( 
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
        $(go.Panel,"Spot",
          $(go.Shape, "Rectangle", 
          {  
            name: "SHAPE",
            width: 48, 
            height: 25, 
            fill: this.color,
            stroke:'transparent',
          },
          new go.Binding("fill", "fill").makeTwoWay(),
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay()
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
        ),
           $(
            go.TextBlock,
            {
              background: "transparent",
              editable: true,
              isMultiline: false,
              verticalAlignment: go.Spot.Center,
              font: "18px serif",
              margin:8
            },
            new go.Binding("text", "title").makeTwoWay()
            ),
      //双击事件
      {
        // if double-clicked, an input node will change its value, represented by the color.
        // doubleClick: function(e, obj) {
        //   var data = obj.part.data;
        //    ////console.log(data)
        //   if(_this.logic(data.key)){
        //     _this.changeStyle(data.key, data.fill);
        //      _this.updateStates(data.key);
        //   }
          
        // }
      }
    );
    var vonoff  = $( 
      go.Node,
      "Horizontal",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE", },
        $(go.Panel,"Spot",
          $(go.Shape, "Rectangle", 
          {  
            name: "SHAPE",
            width: 30, 
            height: 48, 
            fill: this.color,
            stroke:'transparent',
          },
          new go.Binding("fill", "fill").makeTwoWay(),
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
        ),
           $(
            go.TextBlock,
            {
              background: "transparent",
              editable: true,
              isMultiline: false,
              verticalAlignment: go.Spot.Center,
              font: "18px serif",
              margin:8
            },
            new go.Binding("text", "title").makeTwoWay()
            ),
    );
    var onoff2  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "Rectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: this.offcolor,
              stroke:'transparent',
              },
          new go.Binding("fill", "fill").makeTwoWay(),
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var oilGroove  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "Circle",
          {  
              name: "SHAPE",
              width: 70, 
              height: 70, 
              fill: 'transparent',
              stroke:'#333333',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(
            go.TextBlock, { font: "16px sans-serif", text: "压油槽" }
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    );
    var pressureGroove  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "Circle",
          {  
              name: "SHAPE",
              width: 70, 
              height: 70, 
              fill: 'transparent',
              stroke:'#333333',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(
            go.TextBlock, { font: "16px sans-serif", text: "压气槽" }
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    );
    var myCircle  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Circle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'#999999',
              strokeWidth: 1,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(
            go.TextBlock,
            {
              font: "10px serif",
              verticalAlignment: go.Spot.Center,
              textAlign:"center",
              stroke:'red',
            },
            new go.Binding("text", "title").makeTwoWay()
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    );
    //矩形
    var block  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      // new go.Binding("location","loc").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "Rectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'#333333',
              strokeWidth: 2,
              
          },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var redblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "Rectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'red',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var blueblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "Rectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'blue',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var yellowblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "Rectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'yellow',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var purpleblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "Rectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'purple',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var greenblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "Rectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'green',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var orangeblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "Rectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'orange',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var cyanblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "Rectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'cyan',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    
    // 圆角矩形
    var roundedRectangle  =$(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      { resizable: true,resizeObjectName: "SHAPE", },
         $(go.Panel,"Spot",
          $(go.Shape, "RoundedRectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'#333333',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    )
    var redroundeblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "RoundedRectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'red',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var blueroundeblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "RoundedRectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'blue',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var yellowroundeblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "RoundedRectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'yellow',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var purpleroundeblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "RoundedRectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'purple',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var greenroundeblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "RoundedRectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'green',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var orangeroundeblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "RoundedRectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'orange',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var cyanroundeblock  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
         $(go.Panel,"Spot",
          $(go.Shape, "RoundedRectangle",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:'cyan',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    //六边形
    var DataTransmissions = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE",rotatable:true  },
      $(go.Panel,"Spot",
          $(go.Shape, "DataTransmissions",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
      ),
    );
    var redsix  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "DataTransmissions",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'red',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
    var yellowsix  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "DataTransmissions",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'yellow',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
    var bluesix  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "DataTransmissions",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'blue',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
    var greensix  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "DataTransmissions",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'green',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
    var cyansix  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "DataTransmissions",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'cyan',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
    var purplesix  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "DataTransmissions",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'purple',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
    var orangesix  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "DataTransmissions",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'orange',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
    //圆形
    var ellipse = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
      $(go.Panel,"Spot",
          $(go.Shape, "Circle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              strokeWidth: 2,
              },
          // new go.Binding("fill", "fill").makeTwoWay(),
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    );
    var redC  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Circle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'red',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    );
    var yellowC  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Circle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'yellow',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    );
    var blueC = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Circle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'blue',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    );
    var greenC  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Circle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'green',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    );
    var cyanC  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Circle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'cyan',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    );
    var purpleC  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Circle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'purple',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
                    $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    );
    var orangeC  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Circle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'orange',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
                    $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    );
        //三角形
    var triangle = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
      },
      $(go.Panel,"Spot",
          $(go.Shape, "Triangle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'#333333',
              strokeWidth: 2,
              },
          // new go.Binding("fill", "fill").makeTwoWay(),
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
      ),
    );
    var redS  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Triangle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'red',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
    var yellowS  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Triangle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'yellow',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
    var blueS = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Triangle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'blue',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),

      ),
    );
    var greenS  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Triangle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'green',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
    var cyanS  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Triangle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'cyan',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
    var purpleS  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Triangle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'purple',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
    var orangeS  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true, resizeObjectName: "SHAPE",},
         $(go.Panel,"Spot",
          $(go.Shape, "Triangle",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'orange',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          ),
      ),
    );
   
      
    

    //菱形
    var Decision = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE", rotatable:true},
      $(go.Panel,"Spot",
          $(go.Shape, "Decision",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'#520404',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
    );


    //横线
    var lineH = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),

      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
        avoidable:false,
        rotatable:true
      },
      $(go.Panel,"Spot",
          $(go.Shape, "LineH",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'#aeaeae',
              strokeWidth: 2,
            },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
      ),
    );
    //直线
    var lineV = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE", avoidable:false,rotatable:true},
      $(go.Panel,"Spot",
          $(go.Shape, "lineV",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'#aeaeae',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
      ),
    );
    //上T
    var LogicTruth = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE", avoidable:false,rotatable:true},
      $(go.Panel,"Spot",
          $(go.Shape, "LogicTruth",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'#aeaeae',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
      ),
    );
    //下T
    var LogicFalsity = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE", avoidable:false,rotatable:true},
      $(go.Panel,"Spot",
          $(go.Shape, "LogicFalsity",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'#aeaeae',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
      ),
    );
    // W 线
    var Resistor = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE", rotatable:true},
      $(go.Panel,"Spot",
          $(go.Shape, "Resistor",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'blue',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
      ),
    );

    //折线
    var LogicNot = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE",rotatable:true, avoidable:false, },
      $(go.Panel,"Spot",
          $(go.Shape, "LogicNot",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'#aeaeae',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
      ),
    );
    //下弧形
    var LogicIntersect = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE",rotatable:true, avoidable:false, },
      $(go.Panel,"Spot",
          $(go.Shape, "LogicIntersect",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'#aeaeae',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
      ),
    );
    //上弧形
    var LogicUnion = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE",rotatable:true ,avoidable:false, },
      $(go.Panel,"Spot",
          $(go.Shape, "LogicUnion",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'#aeaeae',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
      ),
    );
    //带线菱形
    var Sort = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE",rotatable:true  },
      $(go.Panel,"Spot",
          $(go.Shape, "Sort",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'#520404',
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
      ),
    ); 
    // 交叉线
    var pushLine = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
        avoidable:false,
        rotatable:true
      },
      $(go.Panel,"Spot",
          $(go.Shape, "PlusLine",
          {  
              name: "SHAPE",
              width: 30, 
              height: 30, 
              fill: 'transparent',
              stroke:'#aeaeae',
              strokeWidth: 2,
              },
          // new go.Binding("fill", "fill").makeTwoWay(),
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
        $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );



//阀门  统一一个 
    var cat  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        resizable: true,
        resizeObjectName: "SHAPE", // 拉伸图形
        rotatable:true
      },
         $(go.Panel,"Spot",
          $(go.Shape, "Collate",
          {  
              name: "SHAPE",
              width: 48, 
              height: 25, 
              fill: 'transparent',
              stroke:this.color,
              strokeWidth: 2,
              },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          new go.Binding("stroke", "stroke").makeTwoWay()

          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(0.5, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0.5, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin: 8,
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );

//  闸刀 能切换大小
    var door  = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE",rotatable:true},
         $(go.Panel,"Spot",
          $(go.Shape, "Delete",
          {  
            name: "SHAPE",
            width: 33, 
            height: 33, 
            fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
          },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          new go.Binding("stroke", "stroke").makeTwoWay(),
          ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
      ),
      //  $(
      //     go.TextBlock,
      //     {
      //       background: "transparent",
      //       editable: true,
      //       isMultiline: false,
      //       verticalAlignment: go.Spot.Center,
      //       font: "18px serif",
      //       margin: 8,
      //     },
      //     new go.Binding("text", "title").makeTwoWay()
      //   ),
    );






    var triangleTemplate = $(
      go.Node,
      "Horizontal",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      { resizable: true,resizeObjectName: "SHAPE"},// 拉伸图形
        $(go.Panel,"Spot",
      //$(go.Panel,"Vertical",
        $(go.Shape,
          this.shapeStyle(),
          {
            figure: "Collate",
             fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 25,
            height: 46
          },
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
        $(go.Shape, {
          figure: "MinusLine",
          stroke: this.color,
          strokeWidth: 2,
          width: 25,
          height: 0
        },
        new go.Binding("stroke", "stroke").makeTwoWay()),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
        ),
           $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var triangle1Template = $(
      go.Node,
      "Horizontal",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("angle","angle").makeTwoWay(),
      { resizable: true,resizeObjectName: "SHAPE"},// 拉伸图形
      $(go.Panel,"Spot",
      $(
        go.Panel,
        "Vertical",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Collate",
            fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 25,
            height: 46
          },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
      ),
       $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
        portId: "T",
        alignment: new go.Spot(0.5, 0)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
        portId: "B",
        alignment: new go.Spot(0.5, 1)
      }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            alignment: go.Spot.Right
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var triangle2Template = $(
      go.Node,
      "Horizontal",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
       $(go.Panel,"Spot",
      //$(go.Panel,"Vertical",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Collate",
             fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 25,
            height: 46
          },
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
        $(go.Shape, {
          figure: "MinusLine",
           fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 25,
            height: 0
          },
          new go.Binding("stroke", "stroke").makeTwoWay()),
      //),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
        portId: "T",
        alignment: new go.Spot(0.5, 0)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
        portId: "B",
        alignment: new go.Spot(0.5, 1)
      }),
       ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
      {
        // if double-clicked, an input node will change its value, represented by the color.
        // doubleClick: function(e, obj) {
        //   var data = obj.part.data;
        //   if(_this.logic(data.key)){
        //     _this.changeStroke(data.key, data.stroke);
        //     _this.updateStates(data.key);
        //   }else{
        //   }
        // }
      }
    );
    var triangle3Template = $(
      go.Node,
      "Horizontal",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
       $(go.Panel,"Spot",
      $(go.Panel,"Vertical",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Collate",
            fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 25,
            height: 46
          },
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
      ),
       $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
        portId: "T",
        alignment: new go.Spot(0.5, 0)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
        portId: "B",
        alignment: new go.Spot(0.5, 1)
      }),
       ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var valve = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
       $(go.Panel,"Spot",
      $(
        go.Panel,
        "Horizontal",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Collate",
            fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 25,
            height: 46,
            angle:90
          },
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
      ),
       $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R",
          alignment: new go.Spot(1, 0.5)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L",
          alignment: new go.Spot(0, 0.5)
        }),
       ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin:8
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var valveoff = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {resizable: true,resizeObjectName: "SHAPE",},
       $(go.Panel,"Spot",
      $(
        go.Panel,
        "Horizontal",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Collate",
            fill: 'transparent',
            stroke:this.offcolor,
            strokeWidth: 2,
            angle:90
          },
          new go.Binding("width").makeTwoWay(),
          new go.Binding("height").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay(),
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
      ),
       $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
        portId: "R",
        alignment: new go.Spot(1, 0.5)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
        portId: "L",
        alignment: new go.Spot(0, 0.5)
      }),
       ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin:8
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var htriangle2Template = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
       $(go.Panel,"Spot",
      //$(go.Panel,"Horizontal",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Collate",
            fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 25,
            height: 46,
            angle:90
          },
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
        $(go.Shape, {
          figure: "LineV",
           stroke:this.color,
            strokeWidth: 2,
          width: 0,
          height: 23
        },
         new go.Binding("stroke", "stroke").makeTwoWay()),
      //),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
        portId: "R",
        alignment: new go.Spot(1, 0.5)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
        portId: "L",
        alignment: new go.Spot(0, 0.5)
      }),
       ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin:8
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var htriangle3Template = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
       $(go.Panel,"Spot",
      //$(go.Panel,"Horizontal",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Collate",
             fill: 'transparent',
            stroke:this.offcolor,
            strokeWidth: 2,
            width: 25,
            height: 46,
            angle:90
          },
           new go.Binding("stroke", "stroke").makeTwoWay()
        ),
         $(go.Shape, {
          figure: "LineV",
           stroke:this.color,
            strokeWidth: 2,
          width: 0,
          height: 23
        },
         new go.Binding("stroke", "stroke").makeTwoWay()),
      //),
       $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
        portId: "R",
        alignment: new go.Spot(1, 0.5)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
        portId: "L",
        alignment: new go.Spot(0, 0.5)
      }),
       ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin:8
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var rectangle = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(
        go.Panel,
        "Vertical",
        $(go.Shape, {
          figure: "Rectangle",
          fill: gray,
          width: 60,
          height: 10
        }),
        $(go.Shape, {
          figure: "Rectangle",
          fill: black,
          width: 30,
          height: 10
        }),
        $(go.Shape, {
          figure: "Rectangle",
          fill: gray,
          width: 60,
          height: 30
        })
      ),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
        portId: "R",
        alignment: new go.Spot(1, 0.8)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
        portId: "L",
        alignment: new go.Spot(0, 0.5)
      })
    );
    var edittext = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(
        go.TextBlock,
        {
          background: white,
          editable: true,
          isMultiline: false,
          verticalAlignment: go.Spot.Center,
          font: "18px serif",
          height: 20
        },
        new go.Binding("text", "title").makeTwoWay()
      ),
    );
    var red = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(
        go.TextBlock,
        {
          background: white,
          editable: true,
          isMultiline: false,
          verticalAlignment: go.Spot.Center,
          font: "18px serif",
          height: 20,
          stroke:"red"
        },
        new go.Binding("text", "title").makeTwoWay()
      ),
    );
    var cyan = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(
        go.TextBlock,
        {
          background: white,
          editable: true,
          isMultiline: false,
          verticalAlignment: go.Spot.Center,
          font: "18px serif",
          height: 20,
          stroke:"cyan"
        },
        new go.Binding("text", "title").makeTwoWay()
      ),
    );
    var green = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(
        go.TextBlock,
        {
          background: white,
          editable: true,
          isMultiline: false,
          verticalAlignment: go.Spot.Center,
          font: "18px serif",
          height: 20,
          stroke:"green"
        },
        new go.Binding("text", "title").makeTwoWay()
      ),
    );
    var blue = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(
        go.TextBlock,
        {
          background: white,
          editable: true,
          isMultiline: false,
          verticalAlignment: go.Spot.Center,
          font: "18px serif",
          height: 20,
          stroke:"blue"
        },
        new go.Binding("text", "title").makeTwoWay()
      ),
    );
    var yellow = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(
        go.TextBlock,
        {
          background: white,
          editable: true,
          isMultiline: false,
          verticalAlignment: go.Spot.Center,
          font: "18px serif",
          height: 20,
          stroke:"yellow"
        },
        new go.Binding("text", "title").makeTwoWay()
      ),
    );
    var purple = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(
        go.TextBlock,
        {
          background: white,
          editable: true,
          isMultiline: false,
          verticalAlignment: go.Spot.Center,
          font: "18px serif",
          height: 20,
          stroke:"purple"
        },
        new go.Binding("text", "title").makeTwoWay()
      ),
    );
    var orange = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(
        go.TextBlock,
        {
          background: white,
          editable: true,
          isMultiline: false,
          verticalAlignment: go.Spot.Center,
          font: "18px serif",
          height: 20,
          stroke:"orange"
        },
        new go.Binding("text", "title").makeTwoWay()
      ),
    );
    var Btext = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(
        go.TextBlock,
        {
          background: white,
          editable: true,
          isMultiline: false,
          verticalAlignment: go.Spot.Center,
          font: "bold 24px serif ",
          height: 30,
        },
        new go.Binding("text", "title").makeTwoWay()
      ),
    );
    var straight = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        selectionAdorned: false, // don't show the standard selection handle
        resizable: true,
        resizeObjectName: "SHAPE", // user can resize the Shape
        rotatable: true,
        rotateObjectName: "SHAPE" // user can rotate the Shape                                           // without rotating the label
      },
      $(
        go.Shape,
        {
          name: "SHAPE",
          fill: $(go.Brush, "Linear", { 0.0: "white", 1.0: "#000" }),
          desiredSize: new go.Size(100, 50),
          width: 60,
          height: 5
        },
        new go.Binding("width").makeTwoWay(),
        new go.Binding("figure", "figure")
      ),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
        portId: "T",
        alignment: new go.Spot(0.5, 0)
      })
    );
    var circleText = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(
        go.Panel,
        "Auto",
        $(go.Shape, this.shapeStyle(), {
          figure: "Circle",
          fill: white,
          width: 18,
          height: 18
        }),
        $(
          go.TextBlock,
          {
            font: "12px sans-serif",
            stroke: "#000",
            editable: true,
            isMultiline: false
          },
          new go.Binding("text", "title").makeTwoWay()
        )
      ),

      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
        portId: "R",
        alignment: new go.Spot(1, 0.5)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
        portId: "L",
        alignment: new go.Spot(0, 0.5)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
        portId: "T",
        alignment: new go.Spot(0.5, 0)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
        portId: "B",
        alignment: new go.Spot(0.5, 1)
      })
    );
    var verticalLine = $(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      {
        selectionAdorned: false, // don't show the standard selection handle
        resizable: true,
        resizeObjectName: "SHAPE", // user can resize the Shape
        rotatable: true,
        rotateObjectName: "SHAPE" // user can rotate the Shape                                           // without rotating the label
      },
      $(
        go.Shape,
        {
          name: "SHAPE",
          fill: $(go.Brush, "Linear", { 0.0: "white", 1.0: "#000" }),
          desiredSize: new go.Size(100, 50),
          height: 40,
          width: 0
        },
        new go.Binding("height").makeTwoWay(),
        new go.Binding("figure", "figure")
      )
    );
    var knife=$(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      { resizable: true,resizeObjectName: "SHAPE", },
       $(
        go.Panel,
        "Spot",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Delete",
            fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 35,
            height: 35,
            angle:90
          },
          new go.Binding("stroke", "stroke").makeTwoWay(),
          new go.Binding("angle","angle").makeTwoWay()
        ),
      ),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
        portId: "R",
        alignment: new go.Spot(1, 0.5)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
        portId: "L",
        alignment: new go.Spot(0, 0.5)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
        portId: "T",
        alignment: new go.Spot(0.5, 0)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
        portId: "B",
        alignment: new go.Spot(0.5, 1)
      }),
    );
    var knifeoff=$(
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
       $(
        go.Panel,
        "Spot",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Delete",
            fill: 'transparent',
            stroke:this.offcolor,
            strokeWidth: 2,
            width: 35,
            height: 35,
            
          },
          new go.Binding("stroke", "stroke").makeTwoWay(),
          new go.Binding("angle", "angle").makeTwoWay()
        ),
      //  $(go.Shape, {
      //     figure: "LineH",
      //     width:35,
      //     height:0,
      //     stroke:this.offcolor,
      //     strokeWidth: 2,
      //     angle:this.angle,
      //     alignment: new go.Spot(0.5, 0.5)
      //   },
      //   new go.Binding("stroke", "stroke").makeTwoWay(),
      //    new go.Binding("angle", "angle").makeTwoWay()
      //   ),
      ),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
        portId: "R",
        alignment: new go.Spot(1, 0.5)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
        portId: "L",
        alignment: new go.Spot(0, 0.5)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
        portId: "T",
        alignment: new go.Spot(0.5, 0)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
        portId: "B",
        alignment: new go.Spot(0.5, 1)
      }),
      {
        // if double-clicked, an input node will change its value, represented by the color.
        // doubleClick: function(e, obj) {
        //    var data = obj.part.data;
        //    if(_this.logic(data.key)){
        //     _this.changeAngle(data.key, data.angle);
        //     _this.changeStroke(data.key, data.stroke);
        //     _this.updateStates(data.key);
        //    }else{
        //    }
        // }
      }
    );
    //单独写的图片
    var mainDistributionValve =$(go.Node, "Auto",this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("angle").makeTwoWay(),
      { resizable: true,resizeObjectName: "SHAPE"},// 拉伸图形
        $(go.Panel, "Vertical",
            $(
            go.Picture,
            // this.imgStyle(),
            { width: _this.myWidth, height: _this.myHeight ,},
            // new go.Binding("source", "source").makeTwoWay(),
            // new go.Binding("width", "width").makeTwoWay(),
            // new go.Binding("height", "height").makeTwoWay()
          ),
            
        ),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R",
          alignment: new go.Spot(0.75, 0.5)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R2",
          alignment: new go.Spot(0.75, 0.62)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R3",
          alignment: new go.Spot(0.75, 0.73)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R4",
          alignment: new go.Spot(0.6, 0.2)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R5",
          alignment: new go.Spot(0.6, 0.25)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R6",
          alignment: new go.Spot(0.6, 0.3)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L",
          alignment: new go.Spot(0.13, 0.5)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T",
          alignment: new go.Spot(0.5, 0)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B",
          alignment: new go.Spot(0.5, 0.9)
        }),
    );
    var electricValve = $(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("angle","angle").makeTwoWay(),
      $(go.Panel,"Spot",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Collate",
             fill: 'transparent',
            stroke:this.offcolor,
            strokeWidth: 2,
            width: 25,
            height: 46,
            angle:90
          },
           new go.Binding("stroke", "stroke").makeTwoWay()
        ),
         $(go.Shape, {
          figure: "circle",
          fill:"#ff00ff",
           stroke:"#ff00ff",
            strokeWidth: 2,
          width: 10,
          height: 10,
          alignment: new go.Spot(0.5, 0)
        },
         ),
         $(go.Shape, {
          figure: "lineV",
          stroke:"#ff00ff",
          strokeWidth: 2,
          height: 9,
          alignment: new go.Spot(0.5, 0.3)
        },
         ),
       $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
        portId: "R",
        alignment: new go.Spot(1, 0.5)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
        portId: "L",
        alignment: new go.Spot(0, 0.5)
      }),
      ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin:8
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    //单独写的图片
    var switchValve =$(go.Node, "Auto",this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("angle").makeTwoWay(),
      $(go.Panel, "Vertical",
            $(
            go.Picture,
            this.imgStyle(),
            { width: 30, height: 25 ,},
            new go.Binding("source", "source").makeTwoWay(),
            new go.Binding("width", "width").makeTwoWay(),
            new go.Binding("height", "height").makeTwoWay()
          ),
        ),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R",
          alignment: new go.Spot(1, 0.5)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L",
          alignment: new go.Spot(0, 0.5)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T",
          alignment: new go.Spot(0.5, 0)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T1",
          alignment: new go.Spot(0.23, 0)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T2",
          alignment: new go.Spot(0.8, 0)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B",
          alignment: new go.Spot(0.5, 1)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B1",
          alignment: new go.Spot(0.23, 1)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B2",
          alignment: new go.Spot(0.8, 1)
        }),
    );
    //单独写的图片
    var switchValve2 =$(go.Node, "Auto",this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("angle").makeTwoWay(),
      $(go.Panel, "Vertical",
            $(
            go.Picture,
            this.imgStyle(),
            { width: 30, height: 25 ,},
            new go.Binding("source", "source").makeTwoWay(),
            new go.Binding("width", "width").makeTwoWay(),
            new go.Binding("height", "height").makeTwoWay()
          ),
        ),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R",
          alignment: new go.Spot(1, 0.5)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L",
          alignment: new go.Spot(0, 0.5)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T",
          alignment: new go.Spot(0.5, 0)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T1",
          alignment: new go.Spot(0.12, 0)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T2",
          alignment: new go.Spot(0.36, 0)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T3",
          alignment: new go.Spot(0.67, 0)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T4",
          alignment: new go.Spot(0.9, 0)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B",
          alignment: new go.Spot(0.5, 1)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B1",
          alignment: new go.Spot(0.12, 1)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B2",
          alignment: new go.Spot(0.36, 1)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B3",
          alignment: new go.Spot(0.67, 1)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B4",
          alignment: new go.Spot(0.9, 1)
        }),
    );
    //单独写的图片
    var switchValve3 =$(go.Node, "Auto",this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("angle").makeTwoWay(),
      $(go.Panel, "Vertical",
            $(
            go.Picture,
            this.imgStyle(),
            { width: 30, height: 25 ,},
            new go.Binding("source", "source").makeTwoWay(),
            new go.Binding("width", "width").makeTwoWay(),
            new go.Binding("height", "height").makeTwoWay()
          ),
        ),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R",
          alignment: new go.Spot(1, 0.5)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R1",
          alignment: new go.Spot(1, 0.1)
        }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R2",
          alignment: new go.Spot(1, 0.33)
        }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R3",
          alignment: new go.Spot(1, 0.63)
        }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R4",
          alignment: new go.Spot(1, 0.88)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L",
          alignment: new go.Spot(0, 0.5)
        }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L1",
          alignment: new go.Spot(0, 0.1)
        }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L2",
          alignment: new go.Spot(0, 0.33)
        }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L3",
          alignment: new go.Spot(0, 0.63)
        }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L4",
          alignment: new go.Spot(0, 0.88)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T",
          alignment: new go.Spot(0.5, 0)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B",
          alignment: new go.Spot(0.5, 1)
        }),
    );
    //单独写的图片
    var switchValve4 =$(go.Node, "Auto",this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("angle").makeTwoWay(),
      $(go.Panel, "Vertical",
            $(
            go.Picture,
            this.imgStyle(),
            { width: 30, height: 25 ,},
            new go.Binding("source", "source").makeTwoWay(),
            new go.Binding("width", "width").makeTwoWay(),
            new go.Binding("height", "height").makeTwoWay()
          ),
        ),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R",
          alignment: new go.Spot(1, 0.5)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R1",
          alignment: new go.Spot(1, 0.06)
        }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R2",
          alignment: new go.Spot(1, 0.38)
        }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R3",
          alignment: new go.Spot(1, 0.62)
        }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R4",
          alignment: new go.Spot(1, 0.94)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L",
          alignment: new go.Spot(0, 0.5)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L1",
          alignment: new go.Spot(0, 0.22)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L2",
          alignment: new go.Spot(0, 0.78)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T",
          alignment: new go.Spot(0.5, 0)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B",
          alignment: new go.Spot(0.5, 1)
        }),
    );
    //单独写的图片
    var emergencyDistributionValve=$(go.Node, "Auto",this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("angle").makeTwoWay(),
      $(go.Panel, "Vertical",
            $(
            go.Picture,
            this.imgStyle(),
            { width: 30, height: 25 ,},
            new go.Binding("source", "source").makeTwoWay(),
            new go.Binding("width", "width").makeTwoWay(),
            new go.Binding("height", "height").makeTwoWay()
          ),
        ),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R",
          alignment: new go.Spot(1, 0.5)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L",
          alignment: new go.Spot(0, 0.5)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T",
          alignment: new go.Spot(0.5, 0)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T1",
          alignment: new go.Spot(0.085, 0)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T2",
          alignment: new go.Spot(0.36, 0)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T3",
          alignment: new go.Spot(0.64, 0)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T4",
          alignment: new go.Spot(0.9, 0)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T5",
          alignment: new go.Spot(0.76, 0)
        }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T6",
          alignment: new go.Spot(0.23, 0)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B",
          alignment: new go.Spot(0.5, 1)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B1",
          alignment: new go.Spot(0.085, 1)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B2",
          alignment: new go.Spot(0.36, 1)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B3",
          alignment: new go.Spot(0.64, 1)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B4",
          alignment: new go.Spot(0.9, 1)
        }), 
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B5",
          alignment: new go.Spot(0.76, 1)
        }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B6",
          alignment: new go.Spot(0.23, 1)
        }),
    );
    
    //单独写的图片
    var servomotor =$(go.Node, "Auto",this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("angle").makeTwoWay(),
      $(go.Panel, "Vertical",
            $(
            go.Picture,
            this.imgStyle(),
            { width: 30, height: 25 ,},
            new go.Binding("source", "source").makeTwoWay(),
            new go.Binding("width", "width").makeTwoWay(),
            new go.Binding("height", "height").makeTwoWay()
          ),
        ),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
          portId: "R",
          alignment: new go.Spot(1, 0.5)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
          portId: "L",
          alignment: new go.Spot(0, 0.5)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T",
          alignment: new go.Spot(0.5, 0)
        }),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T1",
          alignment: new go.Spot(0.2, 0)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B",
          alignment: new go.Spot(0.5, 1)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B1",
          alignment: new go.Spot(0.2, 1)
        }),
    );
    var drawer = $(
      go.Node,
      "Horizontal",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("category").makeTwoWay(),
      $(go.Panel,"Spot",
      $(go.Panel,"Vertical",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "LogicAnd",
            fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 35,
            height: 22
          },
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
        $(go.Shape, {
          figure: "LogicIff",
           fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            //width: 30,
            angle:90,
            height: 35
          },
          new go.Binding("stroke", "stroke").makeTwoWay()),
        $(
          go.Shape,
          this.shapeStyle2(),
          {
            figure: "LogicOr",
            fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 35,
            height: 22
          },
          new go.Binding("stroke", "stroke").makeTwoWay()
        )
      ),
       $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
        portId: "T",
        alignment: new go.Spot(0.5, 0)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
        portId: "B",
        alignment: new go.Spot(0.5, 1)
      }),
      ),
      //  $(
      //     go.TextBlock,
      //     {
      //       background: "transparent",
      //       editable: true,
      //       isMultiline: false,
      //       verticalAlignment: go.Spot.Center,
      //       font: "18px serif",
      //     },
      //     new go.Binding("text", "title").makeTwoWay()
      //   ),
      {
        // if double-clicked, an input node will change its value, represented by the color.
        // doubleClick: function(e, obj) {
        //   var data = obj.part.data;
        //   if(_this.logic(data.key)){
        //     _this.changeCategory(data.key,data.category)
        //     _this.changeStroke(data.key, data.stroke);
        //     _this.updateStates(data.key);
        //   }else{
        //   }
        // }
      }
    );
    var drawer2 = $(
      go.Node,
      "Horizontal",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(go.Panel,"Spot",
      $(go.Panel,"Vertical",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Capacitor",
            fill: 'transparent',
            stroke:this.offcolor,
            strokeWidth: 2,
            width: 20,
            //height: 22,
            angle:90
          },
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
        $(go.Shape, {
          figure: "LineV",
           fill: 'transparent',
            stroke:this.offcolor,
            strokeWidth: 2,
            //width: 30,
            height: 60
          },
          new go.Binding("stroke", "stroke").makeTwoWay()),
        $(
          go.Shape,
          this.shapeStyle2(),
          {
            figure: "Capacitor",
            fill: 'transparent',
            stroke:this.offcolor,
            strokeWidth: 2,
            width: 20,
            //height: 22
            angle:90
          },
          new go.Binding("stroke", "stroke").makeTwoWay()
        )
      ),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
        portId: "T",
        alignment: new go.Spot(0.5, 0)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
        portId: "B",
        alignment: new go.Spot(0.5, 1)
      }),
      ),
      //  $(
      //     go.TextBlock,
      //     {
      //       background: "transparent",
      //       editable: true,
      //       isMultiline: false,
      //       verticalAlignment: go.Spot.Center,
      //       font: "18px serif",
      //     },
      //     new go.Binding("text", "title").makeTwoWay()
      //   ),
      {
        // if double-clicked, an input node will change its value, represented by the color.
        // doubleClick: function(e, obj) {
        //   var data = obj.part.data;
        //   if(_this.logic(data.key)){
        //     _this.changeCategory(data.key,data.category)
        //     _this.changeStroke(data.key, data.stroke);
        //     _this.updateStates(data.key);
        //   }else{
        //   }
        // }
      }
    );
    var ground=$(
      go.Node,
      "Horizontal",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("angle","angle").makeTwoWay(),
      // {resizable: true,resizeObjectName: "SHAPE", },
      $(
        go.Panel,
        "Vertical",
      $(
        go.Panel,
        "Spot",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Ground",
            fill: 'transparent',
            stroke:this.offcolor,
            strokeWidth: 2,
            width: 50,
          },
    
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T",
          alignment: new go.Spot(0.5, 0)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B",
          alignment: new go.Spot(0.5, 1)
        }),
        ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            margin:7
          },
          new go.Binding("text", "connect").makeTwoWay()
        ),
        ),
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
          },
          new go.Binding("text", "title").makeTwoWay()
        ),
    );
    var Bground=$(
      go.Node,
      "Horizontal",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      new go.Binding("angle","angle").makeTwoWay(),
      $(
        go.Panel,
        "Spot",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "Ground",
            fill: 'transparent',
            stroke:'#aeaeae',
            strokeWidth: 2,
            width: 44,
          },
        ),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
          portId: "T",
          alignment: new go.Spot(0.5, 0)
        }),
        $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
          portId: "B",
          alignment: new go.Spot(0.5, 1)
        }),
        ),
        
    );
    var doubleSwitch=$(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
      $(go.Panel,"Spot",
      $(
        go.Panel,
        "Position",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "LineH",
            fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 40,
          },
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
        $(go.Shape, {
          figure: "Line2",
           stroke:this.color,
            strokeWidth: 2,
          width:30,
          height: 20,
          position: new go.Point(40, 0),
        },
         new go.Binding("stroke", "stroke").makeTwoWay(),
       ),
        $(
          go.Shape,
          this.shapeStyle2(),
          {
            figure: "Capacitor",
            fill: 'transparent',
            stroke:'#000',
           strokeWidth: 2,
            width: 40,
            height: 40,
            angle:90,
            position: new go.Point(70, 0),
          },
          new go.Binding("stroke", "stroke").makeTwoWay(),
        ),
         $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            // margin:5,
            position: new go.Point(110, 0),
          },
          new go.Binding("text", "option1").makeTwoWay()
        ),
         $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            // margin:5,
            position: new go.Point(110, 40),
          },
          new go.Binding("text", "option2").makeTwoWay()
        ),
      ),
         $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R1",
            alignment: new go.Spot(1, 0.8)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.4)
          }),
      
      ),
    );
    var doubleSwitch2=$(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
       $(go.Panel,"Spot",
      $(
        go.Panel,
        "Position",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "LineH",
            fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 40,
          },
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
        $(go.Shape, {
          figure: "LineH",
           stroke:this.color,
            strokeWidth: 2,
          width:30,
          height: 20,
          position: new go.Point(40, 10),
        },
         new go.Binding("stroke", "stroke").makeTwoWay(),
       ),
        $(
          go.Shape,
          this.shapeStyle2(),
          {
            figure: "Capacitor",
            fill: 'transparent',
            stroke:'#000',
           strokeWidth: 2,
            width: 40,
            height: 40,
            angle:90,
            position: new go.Point(70, 0),
          },
          new go.Binding("stroke", "stroke").makeTwoWay(),
        ),
          $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            //margin:10,
            position: new go.Point(110, 0),
          },
          new go.Binding("text", "option1").makeTwoWay()
        ),
         $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            //margin:10,
            position: new go.Point(110, 40),
          },
          new go.Binding("text", "option2").makeTwoWay()
        ),
      ),
       $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
        portId: "R",
        alignment: new go.Spot(1, 0)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
        portId: "R1",
        alignment: new go.Spot(1, 0.8)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
        portId: "L",
        alignment: new go.Spot(0, 0.4)
      }),
       ),
      //  $(
      //     go.TextBlock,
      //     {
      //       background: "transparent",
      //       editable: true,
      //       isMultiline: false,
      //       verticalAlignment: go.Spot.Center,
      //       font: "18px serif",
      //       margin:10
      //     },
      //     new go.Binding("text", "title").makeTwoWay()
      //   ),
      {
        // if double-clicked, an input node will change its value, represented by the color.
        // doubleClick: function(e, obj) {
        //   var data = obj.part.data;
        //   if(_this.logic(data.key)){
        //     _this.changeCategory(data.key,data.category)
        //     _this.changeStroke(data.key, data.stroke);
        //     _this.updateStates(data.key);
        //   }else{
        //   }
        // }
      }
    );
    var doubleSwitch3=$(
      go.Node,
      "Vertical",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
       $(go.Panel,"Spot",
      $(
        go.Panel,
        "Position",
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "LineH",
            fill: 'transparent',
            stroke:this.color,
            strokeWidth: 2,
            width: 40,
          },
          new go.Binding("stroke", "stroke").makeTwoWay()
        ),
        $(go.Shape, {
          figure: "Line1",
           stroke:this.color,
            strokeWidth: 2,
          width:30,
          height: 20,
          position: new go.Point(40, 20),
        },
         new go.Binding("stroke", "stroke").makeTwoWay(),
       ),
        $(
          go.Shape,
          this.shapeStyle2(),
          {
            figure: "Capacitor",
            fill: 'transparent',
            stroke:'#000',
           strokeWidth: 2,
            width: 40,
            height: 40,
            angle:90,
            position: new go.Point(70, 0),
          },
          new go.Binding("stroke", "stroke").makeTwoWay(),
         
        ),
        $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            //margin:10,
            position: new go.Point(110, 0),
          },
          new go.Binding("text", "option1").makeTwoWay()
        ),
         $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "18px serif",
            //margin:10,
            position: new go.Point(110, 40),
          },
          new go.Binding("text", "option2").makeTwoWay()
        ),
      ),
       $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
        portId: "R",
        alignment: new go.Spot(1, 0)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
        portId: "R1",
        alignment: new go.Spot(1, 0.8)
      }),
      $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
        portId: "L",
        alignment: new go.Spot(0, 0.4)
      }),
       ),
      //  $(
      //     go.TextBlock,
      //     {
      //       background: "transparent",
      //       editable: true,
      //       isMultiline: false,
      //       verticalAlignment: go.Spot.Center,
      //       font: "18px serif",
      //       margin:10
      //     },
      //     new go.Binding("text", "title").makeTwoWay()
      //   ),
      {
        // if double-clicked, an input node will change its value, represented by the color.
        // doubleClick: function(e, obj) {
        //   var data = obj.part.data;
        //   if(_this.logic(data.key)){
        //     _this.changeCategory(data.key,data.category) 
        //     _this.changeStroke(data.key, data.stroke);
        //     _this.updateStates(data.key);
        //   }else{
        //   }
        // }
      }
    );
    var toggle = $( 
      go.Node,
      "Spot",
      this.nodeStyle(),
      new go.Binding("zOrder","zOrder").makeTwoWay(),
       $(go.Panel,"Horizontal",
       $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "14px serif",
          },
          new go.Binding("text", "option1").makeTwoWay()
        ),
      $(go.Panel,"Vertical",
      $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "14px serif",
          },
          new go.Binding("text", "option0").makeTwoWay()
        ),
      $(
        go.Panel,
        "Spot",
        //{height:56},
        $(
          go.Shape,
          this.shapeStyle(),
          {
            figure: "RoundedRectangle",
            fill: '#cccccc',
            stroke:"#000",
            width: 40,
            height:40
          },),
        $(go.Shape, {
          figure: "Circle",
          fill:"#fff",
          stroke:"transparent",
          width:26,
          height: 26,
          //position: new go.Point(7, 7),
        },),
        $(
          go.Shape,
          this.shapeStyle2(),
          {
            figure: "RoundedRectangle",
            fill: '#4d4d4d',
            stroke:'transparent',
            width: 6,
            height: 26,
            //position: new go.Point(7, 11),
            angle:300,
          },
          new go.Binding("angle", "angle").makeTwoWay(),
         
        ), $(
          go.Shape,
          this.shapeStyle2(),
          {
            figure: "TriangleUp",
            fill: '#ff0000',
            stroke:'transparent',
            width: 4,
            height: 6,
            //position: new go.Point(7, 11),
            angle:300,
          },
          new go.Binding("angle", "angle").makeTwoWay(),
         
        ),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Right, true, true), {
            portId: "R",
            alignment: new go.Spot(1, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Left, true, true), {
            portId: "L",
            alignment: new go.Spot(0, 0.5)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Top, true, true), {
            portId: "T",
            alignment: new go.Spot(0.5, 0)
          }),
          $(go.Shape, "Rectangle", this.portStyle(go.Spot.Bottom, true, true), {
            portId: "B",
            alignment: new go.Spot(0.5, 1)
          }),
            
          ),
      ),
         $(
          go.TextBlock,
          {
            background: "transparent",
            editable: true,
            isMultiline: false,
            verticalAlignment: go.Spot.Center,
            font: "14px serif",
          },
          new go.Binding("text", "option2").makeTwoWay()
        ),
       ),
    );
    myDiagram.palettegroupTemplate = $(
      go.Group,
      "Vertical",
      new go.Binding("location", "loc", go.Point.parse).makeTwoWay(
        go.Point.stringify
      ),
      $(
        go.Shape, // using a Shape instead of a Placeholder
        {
          fill: "transparent"
        },
        new go.Binding("desiredSize", "size", go.Size.parse).makeTwoWay(
          go.Size.stringify
        )
      )
    );
    myDiagram.groupTemplate = $(
      go.Group,
      "Vertical",
      {
        selectionObjectName: "PH",
        locationObjectName: "PH",
        resizable: true,
        resizeObjectName: "PH"
      },
      new go.Binding("location", "loc", go.Point.parse).makeTwoWay(
        go.Point.stringify
      ),
      {
        mouseEnter: function(e, grp, next) {
          grp.findObject("PH").stroke = "black";
        },
        mouseLeave: function(e, grp, next) {
          grp.findObject("PH").stroke = "transparent";
        },
        mouseDrop: function(e, grp) {
          var ok = grp.addMembers(grp.diagram.selection, true);
          if (!ok) grp.diagram.currentTool.doCancel();
        }
      },
      // $(go.TextBlock,  // group title
      //   { font: "Bold 12pt Sans-Serif" },
      //   new go.Binding("text", "key")),
      $(
        go.Shape, // using a Shape instead of a Placeholder
        { name: "PH", fill: "transparent", stroke: "transparent" },
        new go.Binding("desiredSize", "size", go.Size.parse).makeTwoWay(
          go.Size.stringify
        )
      )
    );
    
    // add the templates created above to myDiagram and palette
    myDiagram.nodeTemplateMap.add("开关", onoff);
    myDiagram.nodeTemplateMap.add("开关3", vonoff);
    myDiagram.nodeTemplateMap.add("方块", block);
    myDiagram.nodeTemplateMap.add("红方块", redblock);
    myDiagram.nodeTemplateMap.add("蓝方块", blueblock);
    myDiagram.nodeTemplateMap.add("紫方块", purpleblock);
    myDiagram.nodeTemplateMap.add("绿方块", greenblock);
    myDiagram.nodeTemplateMap.add("黄方块", yellowblock);
    myDiagram.nodeTemplateMap.add("橙方块", orangeblock);
    myDiagram.nodeTemplateMap.add("青方块", cyanblock);

    myDiagram.nodeTemplateMap.add("圆角矩形", roundedRectangle);
    myDiagram.nodeTemplateMap.add("红圆角方块", redroundeblock);
    myDiagram.nodeTemplateMap.add("蓝圆角方块", blueroundeblock);
    myDiagram.nodeTemplateMap.add("紫圆角方块", purpleroundeblock);
    myDiagram.nodeTemplateMap.add("绿圆角方块", greenroundeblock);
    myDiagram.nodeTemplateMap.add("黄圆角方块", yellowroundeblock);
    myDiagram.nodeTemplateMap.add("橙圆角方块", orangeroundeblock);
    myDiagram.nodeTemplateMap.add("青圆角方块", cyanroundeblock);

    myDiagram.nodeTemplateMap.add("阀门", valve);
    myDiagram.nodeTemplateMap.add("拉伸阀门", cat);
    myDiagram.nodeTemplateMap.add("闸刀", door);

    myDiagram.nodeTemplateMap.add("六边形", DataTransmissions);
    myDiagram.nodeTemplateMap.add("红六边形", redsix);
    myDiagram.nodeTemplateMap.add("黄六边形", yellowsix);
    myDiagram.nodeTemplateMap.add("蓝六边形", bluesix);
    myDiagram.nodeTemplateMap.add("绿六边形", greensix);
    myDiagram.nodeTemplateMap.add("青六边形", cyansix);
    myDiagram.nodeTemplateMap.add("紫六边形", purplesix);
    myDiagram.nodeTemplateMap.add("橙六边形", orangesix);



    myDiagram.nodeTemplateMap.add("阀门3", triangleTemplate);
    myDiagram.nodeTemplateMap.add("阀门4", triangle1Template);
    myDiagram.nodeTemplateMap.add("阀门5", triangle2Template);
    myDiagram.nodeTemplateMap.add("阀门6", triangle3Template);
    myDiagram.nodeTemplateMap.add("阀门7", htriangle2Template);
    myDiagram.nodeTemplateMap.add("阀门8", htriangle3Template);
    myDiagram.nodeTemplateMap.add("电动阀门", electricValve);

    myDiagram.nodeTemplateMap.add("文本", edittext);
    myDiagram.nodeTemplateMap.add("加粗", Btext);
    myDiagram.nodeTemplateMap.add("红", red);
    myDiagram.nodeTemplateMap.add("黄", blue);
    myDiagram.nodeTemplateMap.add("蓝", yellow);
    myDiagram.nodeTemplateMap.add("绿", green);
    myDiagram.nodeTemplateMap.add("紫", purple);
    myDiagram.nodeTemplateMap.add("青", cyan);
    myDiagram.nodeTemplateMap.add("橙", orange);

    myDiagram.nodeTemplateMap.add("圆形", ellipse);
    myDiagram.nodeTemplateMap.add("红圆形", redC);
    myDiagram.nodeTemplateMap.add("黄圆形", yellowC);
    myDiagram.nodeTemplateMap.add("蓝圆形", blueC);
    myDiagram.nodeTemplateMap.add("绿圆形", greenC);
    myDiagram.nodeTemplateMap.add("青圆形", cyanC);
    myDiagram.nodeTemplateMap.add("紫圆形", purpleC);
    myDiagram.nodeTemplateMap.add("橙圆形", orangeC);

    myDiagram.nodeTemplateMap.add("三角形", triangle);
    myDiagram.nodeTemplateMap.add("红三角形", redS);
    myDiagram.nodeTemplateMap.add("黄三角形", blueS);
    myDiagram.nodeTemplateMap.add("蓝三角形", yellowS);
    myDiagram.nodeTemplateMap.add("绿三角形", greenS);
    myDiagram.nodeTemplateMap.add("紫三角形", purpleS);
    myDiagram.nodeTemplateMap.add("青三角形", cyanS);
    myDiagram.nodeTemplateMap.add("橙三角形", orangeS);

    myDiagram.nodeTemplateMap.add("接地桩", ground);
    myDiagram.nodeTemplateMap.add("接地桩1", Bground);
    myDiagram.nodeTemplateMap.add("双头开关", doubleSwitch);
    myDiagram.nodeTemplateMap.add("双头开关2", doubleSwitch2);
    myDiagram.nodeTemplateMap.add("双头开关3", doubleSwitch3);
    myDiagram.nodeTemplateMap.add("切换开关", toggle);
    myDiagram.nodeTemplateMap.add("槽", oilGroove);
    myDiagram.nodeTemplateMap.add("pressureGroove", pressureGroove);
    myDiagram.nodeTemplateMap.add("straight", straight);
    myDiagram.nodeTemplateMap.add("横线", lineH);
    myDiagram.nodeTemplateMap.add("竖线", lineV);
    myDiagram.nodeTemplateMap.add("交叉线", pushLine);
    myDiagram.nodeTemplateMap.add("上T", LogicTruth);
    myDiagram.nodeTemplateMap.add("下T", LogicFalsity);
    myDiagram.nodeTemplateMap.add("W线", Resistor);
    myDiagram.nodeTemplateMap.add("菱形", Decision);
    myDiagram.nodeTemplateMap.add("折线", LogicNot);
    myDiagram.nodeTemplateMap.add("下弧形", LogicIntersect);
    myDiagram.nodeTemplateMap.add("上弧形", LogicUnion);
    myDiagram.nodeTemplateMap.add("带线菱形", Sort);
    myDiagram.nodeTemplateMap.add("带字圆", myCircle);

    
    let myPalette = $(
      go.Palette,
      "myPaletteDiv", // must name or refer to the DIV HTML element
      {
        "animationManager.duration": 800, // slightly longer than default (600ms) animation
        nodeTemplateMap: myDiagram.nodeTemplateMap, // share the templates used by myDiagram
        groupTemplate: myDiagram.palettegroupTemplate,
        model: new go.GraphLinksModel([
          // specify the contents of the Palette
         
          { category: "阀门", stroke:this.color, title: this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:1,stateon:_this.valveon,stateoff:_this.valveoff,width: 25,  height: 46,angle:this.angle},
          { category: "阀门2", stroke:this.offcolor, title: this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:0,stateon:_this.valveon,stateoff:_this.valveoff,width: 25,  height: 46,angle:this.angle,},
          { category: "阀门7", stroke:this.color, title: this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:1,stateon:_this.valveon,stateoff:_this.valveoff ,angle:this.angle },
          { category: "阀门8", stroke:this.offcolor, title: this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:0,stateon:_this.valveon,stateoff:_this.valveoff ,angle:this.angle},
          { category: "电动阀门", stroke:this.offcolor, title: this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:0,stateon:_this.valveon,stateoff:_this.valveoff,angle:this.angle  },
          { category: "阀门3", stroke: this.color, title: this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:1,stateon:_this.valveon,stateoff:_this.valveoff ,width: 25, height: 46 ,angle:this.angle },
          { category: "阀门4", stroke: this.color, title: this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:1,stateon:_this.valveon,stateoff:_this.valveoff,width: 25, height: 46 ,angle:this.angle },
          { category: "阀门5",stroke: this.offcolor, title: this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:0,stateon:_this.valveon,stateoff:_this.valveoff,angle:this.angle },
          { category: "阀门6", stroke: this.offcolor, title: this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:0,stateon:_this.valveon,stateoff:_this.valveoff,width: 25, height: 46,angle:this.angle},
          { category: "抽屉", title: this.infoTitle,fullName:this.fullName,items:[{ height:110,width:40,source:_this.png33 }],zOrder:0,type:1,status:1,stateon:_this.draweron,stateoff:_this.draweroff ,angle:this.angle},
          { category: "抽屉2", title: this.infoTitle,fullName:this.fullName,items:[{ height:100,width:40,source:_this.png34 }],zOrder:0,type:1,status:0,stateon:_this.draweron,stateoff:_this.draweroff ,angle:this.angle},
          { category: "接地桩", stroke: this.offcolor,title: this.infoTitle,fullName:this.fullName,connect:this.groundValue,zOrder:0,type:1,status:0,stateon:this.groundon,stateoff:this.groundoff,width:50,angle:this.angle },
          { category: "切换开关", title: this.infoTitle,fullName:this.fullName,zOrder:0,angle:this.switchangle,type:1,option1:this.option1,option0:this.option0,option2:this.option2,status:1 ,angle:this.angle},
          { category: "双头开关", title: this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:1,option1:this.top1,option0:this.top0,option2:this.top2,angle:this.angle },
          { category: "开关",fill:this.color,title:this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:1,stateon:_this.stateon,stateoff:_this.stateoff,width: 48, height: 25,angle:this.angle },
          { category: "开关3",fill:this.color,title:this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:1,stateon:_this.stateon,stateoff:_this.stateoff,width: 30,height: 48,angle:this.angle },
          { category: "拉伸阀门",stroke: this.color, title: this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:1,stateon:_this.valveon,stateoff:_this.valveoff,width: 25, height: 46,angle:this.angle},
          { category: "闸刀",stroke: this.color, title: this.infoTitle,fullName:this.fullName,zOrder:0,type:1,status:1,stateon:_this.valveon,stateoff:_this.valveoff,width: 35, height: 35,angle:this.angle},
          // { category: "双头开关2", title: this.infoTitle,zOrder:0,type:1,status:0 },
        ]),
         layout: $(go.GridLayout,
          {
            cellSize: new go.Size(1, 1),
            spacing: new go.Size(5, 5), 
          })
      }
    );
    let onoffPalette = $(go.Palette,"onoffPalette", // must name or refer to the DIV HTML element
      {
        "animationManager.duration": 800, // slightly longer than default (600ms) animation
        nodeTemplateMap: myDiagram.nodeTemplateMap, // share the templates used by myDiagram
        groupTemplate: myDiagram.palettegroupTemplate,
        model: new go.GraphLinksModel([
          { category: "方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle},
          { category: "红方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "蓝方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "紫方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "绿方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "黄方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "橙方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "青方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },

          { category: "圆角矩形",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "红圆角方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "蓝圆角方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "紫圆角方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "绿圆角方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "黄圆角方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "橙圆角方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },
          { category: "青圆角方块",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 30, height: 15,angle:this.angle  },

          { category: "圆角",title:this.infoTitle,fullName:this.fullName,zOrder:0,type:999,width: 48, height: 25,angle:this.angle  },
          
          { category: "六边形",title:this.infoTitle,type:999,width: 30, height: 30,angle:this.angle  },
          { category: "红六边形",title:this.infoTitle,type:999,width: 30, height: 30,angle:this.angle  },
          { category: "黄六边形",title:this.infoTitle,type:999,width: 30, height: 30,angle:this.angle  },
          { category: "蓝六边形",title:this.infoTitle,type:999,width: 30, height: 30,angle:this.angle  },
          { category: "绿六边形",title:this.infoTitle,type:999,width: 30, height: 30,angle:this.angle  },
          { category: "青六边形",title:this.infoTitle,type:999,width: 30, height: 30,angle:this.angle  },
          { category: "紫六边形",title:this.infoTitle,type:999,width: 30, height: 30,angle:this.angle  },
          { category: "橙六边形",title:this.infoTitle,type:999,width: 30, height: 30,angle:this.angle  },

          { category: "圆形",zOrder:0,type:999,width: 30, height: 30},
          { category: "红圆形",zOrder:0,type:999,width: 30, height: 30},
          { category: "黄圆形",zOrder:0,type:999,width: 30, height: 30},
          { category: "蓝圆形",zOrder:0,type:999,width: 30, height: 30},
          { category: "青圆形",zOrder:0,type:999,width: 30, height: 30},
          { category: "绿圆形",zOrder:0,type:999,width: 30, height: 30},
          { category: "紫圆形",zOrder:0,type:999,width: 30, height: 30},
          { category: "橙圆形",zOrder:0,type:999,width: 30, height: 30},
          { category: "带字圆",zOrder:0,type:999,width: 30, height: 30},

          { category: "三角形",zOrder:0,type:999,width: 30, height:30,angle:this.angle},
          { category: "红三角形",zOrder:0,type:999,width: 30, height:30,angle:this.angle},
          { category: "黄三角形",zOrder:0,type:999,width: 30, height:30,angle:this.angle},
          { category: "绿三角形",zOrder:0,type:999,width: 30, height:30,angle:this.angle},
          { category: "紫三角形",zOrder:0,type:999,width: 30, height:30,angle:this.angle},
          { category: "青三角形",zOrder:0,type:999,width: 30, height:30,angle:this.angle},
          { category: "蓝三角形",zOrder:0,type:999,width: 30, height:30,angle:this.angle},
          { category: "橙三角形",zOrder:0,type:999,width: 30, height:30,angle:this.angle},
          
          { category: "菱形",zOrder:0,type:999,width: 30, height: 30,angle:this.angle},
          { category: "带线菱形",zOrder:0,type:999,width: 30, height: 30,angle:this.angle},
          { category: "W线",zOrder:0,type:999,width: 30, height: 30,angle:this.angle},
          { category: "横线",zOrder:0,type:999,width: 48, height: 25,angle:this.angle},
          { category: "竖线",zOrder:0,type:999,width: 25, height: 48,angle:this.angle},
          { category: "交叉线",zOrder:0,type:999,width: 30, height: 30,angle:this.angle},
          { category: "上T",zOrder:0,type:999,width: 30, height: 30,angle:this.angle},
          { category: "下T",zOrder:0,type:999,width: 30, height: 30,angle:this.angle},
          { category: "折线",zOrder:0,type:999,width: 30, height: 30,angle:this.angle},
          { category: "上弧形",zOrder:0,type:999,width: 30, height: 30,angle:this.angle},
          { category: "下弧形",zOrder:0,type:999,width: 30, height: 30,angle:this.angle},
          { category: "接地桩1",zOrder:0,type:999,width: 50, height: 50,angle:this.angle},
        
         
         
          { category: "文本", title: this.edittext,zOrder:0 ,type:999},
          { category: "加粗", title: this.edittext,zOrder:0 ,type:999},
          { category: "红", title: this.edittext,zOrder:0 ,type:999},
          { category: "黄", title: this.edittext,zOrder:0 ,type:999},
          { category: "蓝", title: this.edittext,zOrder:0 ,type:999},
          { category: "绿", title: this.edittext,zOrder:0 ,type:999},
          { category: "紫", title: this.edittext,zOrder:0 ,type:999},
          { category: "青", title: this.edittext,zOrder:0 ,type:999},
          { category: "橙", title: this.edittext,zOrder:0 ,type:999},
        ]),
         layout: $(go.GridLayout,
          {
            cellSize: new go.Size(1, 1),
            spacing: new go.Size(5, 5), 
          })
      }
    );
    //第三个图片添加
    let myPalette1 = $(
      go.Palette,
      "myPaletteDiv1", // must name or refer to the DIV HTML element
      {
        "animationManager.duration": 800, // slightly longer than default (600ms) animation
        nodeTemplateMap: myDiagram.nodeTemplateMap, // share the templates used by myDiagram
        groupTemplate: myDiagram.palettegroupTemplate,
        model: new go.GraphLinksModel([
          { category: "槽", fill: white,title:this.oiltext,fullName:this.fullName,width:70 ,height:70,zOrder:0,type:999},
          { category: "pressureGroove", fill: white,width:70,height:70,zOrder:0,type:999 },
          {  title: this.infoTitle,category: "发电机",items:[{ source: _this.png1,width:60,height:60}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "变压器",items:[{ source: _this.png2,width:40,height:70}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "变压器2",items:[{ source: _this.png3,width:40,height:70}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "变压器3",items:[{ source: _this.png4,width:40,height:70}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "变压器4",items:[{ source: _this.png17,width:40,height:70}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "变压器5",items:[{ source: _this.png5,width:65,height:70}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "泵",items:[{ source: _this.png24,width:50,height:50}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "表计",items:[{ source: _this.png8,width:30,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "单向阀",items:[{ source: _this.png16,width:30,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "消弧线圈",items:[{ source: _this.png6,width:6,height:50}],zOrder:0,type:2 }, 
          {  title: this.infoTitle,category: "传感器",items:[{ source: _this.png9,width:45,height:30}],zOrder:0,type:2 },

          {  title: this.infoTitle,category: "1",items:[{ source: _this.png44,width:45,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "2",items:[{ source: _this.png45,width:15,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "3",items:[{ source: _this.png46,width:20,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "4",items:[{ source: _this.png47,width:10,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "5",items:[{ source: _this.png48,width:20,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "6",items:[{ source: _this.png49,width:30,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "7",items:[{ source: _this.png50,width:15,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "8",items:[{ source: _this.png51,width:30,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "9",items:[{ source: _this.png52,width:30,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "10",items:[{ source: _this.png53,width:45,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "11",items:[{ source: _this.png54,width:30,height:40}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "12",items:[{ source: _this.png55,width:45,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "13",items:[{ source: _this.png56,width:45,height:30}],zOrder:0,type:2 },

         
          {  title: this.infoTitle,category: "减压阀",items:[{ source: _this.png15,width:60,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "组合阀",items:[{ source: _this.png23,width:60,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "冷却器",items:[{ source: _this.png21,width:60,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "接力器",items:[{source: _this.png25,width:70,height:30}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "切换阀",items:[{source: _this.png11,width:60,height:30}],zOrder:0,type:2 },//
          {  title: this.infoTitle,category: "切换阀2",items:[{ source: _this.png12,width:60,height:40}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "事故配压阀",items:[{source: _this.png14,width:80,height:40}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "风闸",items:[{ source: _this.png18,width:55,height:60}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "滤水器",items:[{ source: _this.png20,width:30,height:60}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "取水口",items:[{ source: _this.png19,width:40,height:60}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "切换阀3",items:[{source: _this.png13,width:40,height:70}],zOrder:0,type:2 },//
          {  title: this.infoTitle,category: "切换阀4",items:[{ source: _this.png10,width:50,height:110}],zOrder:0,type:2 },
          {  title: this.infoTitle,category: "主配压阀",items:[{source: _this.png22,width:110,height:170}],zOrder:0,type:2 },//
          {  title: this.infoTitle,category: "水轮机",items:[{ source: _this.png26,width:60,height:420}],zOrder:0,type:2 },

        ]),
        layout: $(go.GridLayout,
          {
            cellSize: new go.Size(1, 1),
            spacing: new go.Size(5, 5),
            
          })
      }
    );
    jQuery('#accordion').accordion({
      activate: function (event, ui) {
        
          myPalette.requestUpdate();
          myPalette1.requestUpdate();
          onoffPalette.requestUpdate();
      }
    });
    this.diagram = myDiagram;

    // load the initial diagram
    
    if(this.type==1||this.type==2 || this.type==3|| this.type==4 || this.type==6){
      this.getmapInfo();
    }
    else{
      this.load()
    }
    
    //线动画效果
    // var animation = new go.Animation();
    // animation.easing = go.Animation.EaseLinear;
    // myDiagram.links.each(function(link) {
    //   animation.add(link.findObject("PIPE"), "strokeDashOffset", 20, 0)
    // });
    // // Run indefinitely
    // animation.runCount = Infinity;
    // animation.start();

    // continually update the diagram
    //this.loop();

    myPalette.addDiagramListener("InitialLayoutCompleted", function(
      diagramEvent
    ) {
      var pdrag = document.getElementById("paletteDraggable");
      var palette = diagramEvent.diagram;
      //pdrag.style.width = palette.documentBounds.width + 28 + "px"; // account for padding/borders
      //pdrag.style.height = palette.documentBounds.height + 235 + "px";
    });
    
    $(function() {

      var infoDraggable = document.getElementById("infoDraggable");
      jQuery("#infoDraggable").draggable({ handle: "#infoDraggableHandle" });
      var inspector = new Inspector("myInfo", myDiagram, {
        properties: {
          // key would be automatically added for nodes, but we want to declare it read-only also:
          key: { readOnly: true, show: false },
          comkey: { show: false },
          title:{show:false},
          id:{show:false},
          mapid:{show:false},
          // fill and stroke would be automatically added for nodes, but we want to declare it a color also:
          fill: { show: false, type: "color" },
          stroke: { show:false, type: "color" },
          logicOn: { show: false },
          logicOff: { show: false },
          category:{ show:false },
          loc:{show:false},
          angle:{show:false},
          onlogic: { show: false },
          offlogic: { show: false },
          state:{show:false},
          items:{show:false},
          source:{show:false},
          width:{show:false},
          height:{show:false},
          zOrder:{show:false},
          type:{show:false},
          status:{show:false},
          option1:{show:false},
          option0:{show:false},
          option2:{show:false},
          stateon:{show:false},
          stateoff:{show:false},
          logicChoice2:{show:false},
          describle:{show:false},
          url:{show:false},
          fullName:{show:false},
          connect:{show:false}
        }
      });
    });
  },
  watch: {
  
  },
  computed: {},
  methods: {
    //返回模拟图列表界面  查看模拟图时的返回按钮
    goBackMaplist(){
       this.$router.push({name:'mapList'})
    },
    //获取连接线
    getLine(){
      this.$api.getLine({pagesize:999},res=>{
        this.groundOptions=res.data
      })
    },
    //结束预演
    endSimulate(){
       this.myDialogVisible=true;
    },
    //双击设备 记录添加方法  验证通过
    doubleClickAddRecordForPass(data){
      var _this=this;
      var name=data.category;
      if(_this.type==3){//操作模拟图
        if(name=="接地桩"){
          if(data.status=="1"){
            _this.addOPrateRecord(`将${data.title}切换到接地的状态`)
            if(data.state!=" " && data.state=="0"){
              _this.addWarn(`将${data.title}切换到接地的状态`,'未接地','接地',data.id)
            }else{
              // 否则就是将设备切换到标准状态
              _this.updateWarn(data.mapid,data.id)
            }
          }else{
            _this.addOPrateRecord(`将${data.title}切换到未接地的状态`)
            if(data.state!=" " && data.state=="1"){
              _this.addWarn(`将${data.title}切换到未接地的状态`,'接地','未接地',data.id)
            }else{
              // 否则就是将设备切换到标准状态
              _this.updateWarn(data.mapid,data.id)
            }
          }
        }else if(name.includes("闸刀") || name=="开关" || name=="开关3"){
          if(data.status=="1"){
            _this.addOPrateRecord(`将${data.title}切换到合位的状态`)
            if(data.state!=" " && data.state=="0"){
              ////console.log("告警信息",data.state=="0",data.state)
              _this.addWarn(`将${data.title}切换到合位的状态`,'分位','合位',data.id)
            }else{
              // 否则就是将设备切换到标准状态
              _this.updateWarn(data.mapid,data.id)
            }
          }else{
            _this.addOPrateRecord(`将${data.title}切换到分位的状态`)
            if(data.state!=" " && data.state=="1"){
              _this.addWarn(`将${data.title}切换到分位的状态`,'合位','分位',data.id)
            }else{
              // 否则就是将设备切换到标准状态
              _this.updateWarn(data.mapid,data.id)
            }
          }
        }else if(name.indexOf("阀门")!=-1){
          if(data.status=="1"){
            _this.addOPrateRecord(`将${data.title}切换到开启的状态`)
            if(data.state!=" " && data.state=="0"){
              _this.addWarn(`将${data.title}切换到开启的状态`,'关闭','开启',data.id)
            }else{
              // 否则就是将设备切换到标准状态
              _this.updateWarn(data.mapid,data.id)
            }
          }else{
            _this.addOPrateRecord(`将${data.title}切换到关闭的状态`)
            if(data.state!=" " && data.state=="1"){
              _this.addWarn(`将${data.title}切换到关闭的状态`,'开启','关闭',data.id)
            }else{
              // 否则就是将设备切换到标准状态
              _this.updateWarn(data.mapid,data.id)
            }
          }
        }else if(name=="切换开关"){//还缺标准状态
          if(data.angle=='0'){
            _this.addOPrateRecord(`将${data.title}切换到${data.option0}的状态`)
            ////console.log("切换开关",data.state)
            if(data.state!=" "){
              switch (data.state) {
                case "1":
                  _this.addWarn(`将${data.title}切换到${data.option0}的状态`,data.option1,data.option0,data.id)
                  break;
                case "2":
                  _this.addWarn(`将${data.title}切换到${data.option0}的状态`,data.option2,data.option0,data.id)
                  break;
                case "0":
                   _this.updateWarn(data.mapid,data.id)
                   break;
                default:
                  break;
              }
            }
          }else if(data.angle=='60'){
            _this.addOPrateRecord(`将${data.title}切换到${data.option2}的状态`)
            ////console.log("切换开关",data.state)
            if(data.state!=""&& data.status=="2"){
              switch (data.state) {
                case "1":
                  _this.addWarn(`将${data.title}切换到${data.option2}的状态`,data.option1,data.option2,data.id)
                  break;
                case "0":
                  _this.addWarn(`将${data.title}切换到${data.option2}的状态`,data.option0,data.option2,data.id)
                  break;
                case "2":
                   _this.updateWarn(data.mapid,data.id)
                   break;
                default:
                  break;
              }
            }
          }else{
            _this.addOPrateRecord(`将${data.title}切换到${data.option1}的状态`)
            // ////console.log("切换开关",data.state)
            if(data.state!=" "){
              switch (data.state) {
                case "0":
                  _this.addWarn(`将${data.title}切换到${data.option1}的状态`,data.option0,data.option1,data.id)
                  break;
                case "2":
                  _this.addWarn(`将${data.title}切换到${data.option1}的状态`,data.option2,data.option1,data.id)
                  break;
                case "1":
                   _this.updateWarn(data.mapid,data.id)
                   break;
                default:
                  break;
              }
            }
          }
        }else if(name.indexOf("双头开关")!=-1){
          if(data.category=="双头开关"){
            _this.addOPrateRecord(`将${data.title}切换到${data.option1}的状态`)
            if(data.state!=" "){
              switch (data.state) {
                case "0":
                  _this.addWarn(`将${data.title}切换到${data.option1}的状态`,data.option0,data.option1,data.id)
                  break;
                case "2":
                  _this.addWarn(`将${data.title}切换到${data.option1}的状态`,data.option2,data.option1,data.id)
                  break;
                case "1":
                   _this.updateWarn(data.mapid,data.id)
                   break;
                default:
                  break;
              }
            }
          }else if(data.category=="双头开关2"){
            _this.addOPrateRecord(`将${data.title}切换到${data.option0}的状态`)
            if(data.state!=" "){
              switch (data.state) {
                case "1":
                  _this.addWarn(`将${data.title}切换到${data.option0}的状态`,data.option1,data.option0,data.id)
                  break;
                case "2":
                  _this.addWarn(`将${data.title}切换到${data.option0}的状态`,data.option2,data.option0,data.id)
                  break;
                case "0":
                   _this.updateWarn(data.mapid,data.id)
                   break;
                default:
                  break;
              }
            }
          }else{
            _this.addOPrateRecord(`将${data.title}切换到${data.option2}的状态`)
            if(data.state!=" "){
              switch (data.state) {
                case "0":
                  _this.addWarn(`将${data.title}切换到${data.option2}的状态`,data.option0,data.option2,data.id)
                  break;
                case "1":
                  _this.addWarn(`将${data.title}切换到${data.option2}的状态`,data.option1,data.option2,data.id)
                  break;
                case "2":
                   _this.updateWarn(data.mapid,data.id)
                   break;
                default:
                  break;
              }
            }
          }
        }else if(name.includes("抽屉")){
          if(data.status=="1"){
            _this.addOPrateRecord(`将${data.title}切换到工作位置`)
            if(data.state!=" " && data.state=="0"){
              _this.addWarn(`将${data.title}切换到工作位置`,'检修位置','工作位置',data.id)
            }else{
              // 否则就是将设备切换到标准状态
              _this.updateWarn(data.mapid,data.id)
            }
          }else{
            _this.addOPrateRecord(`将${data.title}切换到检修位置`)
            if(data.state!=" " && data.state=="1"){
              _this.addWarn(`将${data.title}切换到检修位置`,'工作位置','检修位置',data.id)
            }else{
              // 否则就是将设备切换到标准状态
              _this.updateWarn(data.mapid,data.id)
            }
          }
        }
      }else if(_this.type==2){//模拟预演
        var date=new Date().Format("yyyy-MM-dd hh:mm")
        if(name=="接地桩"){
          if(data.status=="1"){
            _this.simulateContent.push({time:date,content:`将${data.title}设备从未接地状态切换到接地状态`,tips:"操作正常"})
          }else{
            _this.simulateContent.push({time:date,content:`将${data.title}设备从接地状态切换到未接地状态`,tips:"操作正常"})
          }
        }else if(name.includes("闸刀") || name.includes("开关")){
          if(data.status=="1"){
            _this.simulateContent.push({time:date,content:`将${data.title}设备从分位状态切换到合位状态`,tips:"操作正常"})
          }else{
            _this.simulateContent.push({time:date,content:`将${data.title}设备从合位状态切换到分位状态`,tips:"操作正常"})
          }
        }else if(name.indexOf("阀门")!=-1){
          if(data.status=="1"){
              _this.simulateContent.push({time:date,content:`将${data.title}设备从关闭状态切换到打开状态`,tips:"操作正常"})
          }else{
            _this.simulateContent.push({time:date,content:`将${data.title}设备从打开状态切换到关闭状态`,tips:"操作正常"})
          }
        }else if(name=="切换开关"){//还缺标准状态
          if(data.angle=='0'){
            _this.simulateContent.push({time:date,content:`将${data.title}设备从${data.option1}切换到${data.option0}的状态`,tips:"操作正常"})
          }else if(data.angle=='60'){
            _this.simulateContent.push({time:date,content:`将${data.title}设备从${data.option0}切换到备用的${data.option2}状态`,tips:"操作正常"})
          }else{
            _this.simulateContent.push({time:date,content:`将${data.title}设备从${data.option2}切换到${data.option1}的状态`,tips:"操作正常"})
          }
        }else if(name.indexOf("双头开关")!=-1){
          if(data.category=="双头开关"){
            _this.simulateContent.push({time:date,content:`将${data.title}设备从${data.option1}位置切换到${data.option2}位置的状态`,tips:"操作正常"})
          }else if(data.category=="双头开关2"){
            _this.simulateContent.push({time:date,content:`将${data.title}设备从${data.option2}位置切换到${data.option0}的状态`,tips:"操作正常"})
          }else{
            _this.simulateContent.push({time:date,content:`将${data.title}设备从${data.option0}切换到${data.option1}的状态`,tips:"操作正常"})
          }
        }else if(name.includes("抽屉")){
          if(data.status=="1"){
              _this.simulateContent.push({time:date,content:`将${data.title}设备从检修位置切换到工作位置`,tips:"操作正常"})
          }else{
            _this.simulateContent.push({time:date,content:`将${data.title}设备从工作位置切换到检修位置`,tips:"操作正常"})
          }
        }
      }
    },
    //双击设备 记录添加方法  验证不通过
    doubleClickAddRecordForReject(data){
      var _this=this;
      if(_this.type==2){
        var name=data.category;
        var date=new Date().Format("yyyy-MM-dd hh:mm")
        if(name=="接地桩"){
          if(data.fill==_this.color){
            _this.simulateContent.push({time:date,content:`将${data.title}设备从未接地状态切换到接地状态`,tips:"条件不具备，禁止操作"})
          }else{
            _this.simulateContent.push({time:date,content:`将${data.title}设备从接地状态切换到未接地状态`,tips:"条件不具备，禁止操作"})
          }
        }else if(name.includes("闸刀") || name.includes("开关")){
          if(data.fill==_this.color){
            _this.simulateContent.push({time:date,content:`将${data.title}设备从分位状态切换到合位状态`,tips:"条件不具备，禁止操作"})
          }else{
            _this.simulateContent.push({time:date,content:`将${data.title}设备从合位状态切换到分位状态`,tips:"条件不具备，禁止操作"})
          }
        }else if(name.indexOf("阀门")!=-1){
          if(data.fill==_this.color){
              _this.simulateContent.push({time:date,content:`将${data.title}设备从关闭状态切换到打开状态`,tips:"条件不具备，禁止操作"})
          }else{
            _this.simulateContent.push({time:date,content:`将${data.title}设备从打开状态切换到关闭状态`,tips:"条件不具备，禁止操作"})
          }
        }else if(name=="切换开关"){//还缺标准状态
          if(data.angle=='0'){
            _this.simulateContent.push({time:date,content:`将${data.title}设备从${data.option1}切换到${data.option0}的状态`,tips:"条件不具备，禁止操作"})
          }else if(data.angle=='60'){
            _this.simulateContent.push({time:date,content:`将${data.title}设备从${data.option0}切换到备用的${data.option2}的状态`,tips:"条件不具备，禁止操作"})
          }else{
            _this.simulateContent.push({time:date,content:`将${data.title}设备从${data.option2}切换到${data.option1}的状态`,tips:"条件不具备，禁止操作"})
          }
        }else if(name.indexOf("双头开关")!=-1){
          if(data.category=="双头开关"){
            _this.simulateContent.push({time:date,content:`将${data.title}设备从${data.option1}位置切换到${data.option2}的状态`,tips:"条件不具备，禁止操作"})
          }else if(data.category=="双头开关2"){
            _this.simulateContent.push({time:date,content:`将${data.title}设备从${data.option2}位置切换到${data.option0}的状态`,tips:"条件不具备，禁止操作"})
          }else{
            _this.simulateContent.push({time:date,content:`将${data.title}设备从${data.option0}切换到${data.option1}的状态`,tips:"条件不具备，禁止操作"})
          }
        }else if(name.includes("抽屉")){
            if(data.fill==_this.color){
              _this.simulateContent.push({time:date,content:`将${data.title}设备从检修位置切换到工作位置`,tips:"条件不具备，禁止操作"})
          }else{
            _this.simulateContent.push({time:date,content:`将${data.title}设备从工作位置切换到检修位置`,tips:"条件不具备，禁止操作"})
          }
        }
      }
      ////console.log("不具备的数据",_this.simulateContent)
    },
    //修改逻辑数组
    changeLogicarr(id){
       let _this=this
       
       //////console.log(this.allmapInfolist,'maplist')
       var logicArr=[]
       for(var i=0;i<this.allmapInfolist.length;i++){
         if(_this.allmapInfolist[i].id==id){
           
           if(_this.allmapInfolist[i].nodedata!=""){
             logicArr=JSON.parse(_this.allmapInfolist[i].nodedata).filter((item)=>{
             if(this.mapid==id){
               return item.id!=_this.clickn.id&&item.type==1&&item.title
             }else{
               return item.type==1&&item.title
             }
            })
           }
           
         }
       }
        //////console.log(logicArr,'logicarr')
       var nd=[]
       if(logicArr.length>0){
         for (var i = 0; i < logicArr.length; i++) {
            var obj = {};
            obj.category = logicArr[i].category;
            obj.label = logicArr[i].title;
            obj.value = logicArr[i].id;
            nd.push(obj);
            _this.infoOptions = nd;
            _this.offinfoOptions = nd;
          }
       }else{
          _this.infoOptions = [];
          _this.offinfoOptions = [];
       }
       
      for (var i = 0; i < _this.infoOptions.length; i++) {
        if(this.infoOptions[i].category=="切换开关"||this.infoOptions[i].category=="双头开关"||this.infoOptions[i].category=="双头开关2"
        ||this.infoOptions[i].category=="双头开关3"){
          for(var k = 0; k < logicArr.length; k++){
            if(_this.infoOptions[i].value==logicArr[k].id){
              _this.infoOptions[i].children = [
                { value: 1, label: logicArr[k].option1 },
                { value: 0, label: logicArr[k].option0 },
                { value: 2, label: logicArr[k].option2 }
              ];
            }
          }
        }
        else{
          _this.infoOptions[i].children = [
            { value: 1, label: logicArr[i].stateon },
            { value: 0, label: logicArr[i].stateoff }
          ];
        }
      }
      _this.offinfoOptions=_this.infoOptions
      _this.choice2infoOptions=_this.infoOptions
      
      return _this.infoOptions
    },
    //新增操作记录  1.修改记录  2.预演记录  3.操作记录
    addUpdateRecord(record){
      if(this.type==1){
        var oldData=this.myData;
        var newData=record;
        var recordcontent=[];
        for(var i=0;i<oldData.length;i++){
          oldData[i]=JSON.stringify(oldData[i])
        }
        for(var i=0;i<newData.length;i++){
          newData[i]=JSON.stringify(newData[i])
        }
        for(var i=0;i<newData.length;i++){
          if(oldData.indexOf(newData[i])==-1){
            recordcontent.push(`新增了${JSON.parse(record[i]).title}`)
          }
        }
        for(var i=0;i<oldData.length;i++){
          if(newData.indexOf(oldData[i])==-1){
            recordcontent.push(`删除了${JSON.parse(this.myData[i]).title}`)
          }
        }
        ////console.log(recordcontent)
        var params={
          elemapid: this.mapid,
          userid:this.elemapInfo.userid,
          type:1,
          recordcontent:recordcontent
        }
        this.$api.addRecord(params,res=>{
          ////console.log(res)
        })
      }
    },
    //新增操作记录
    addOPrateRecord(title){
      ////console.log("操作记录")
      var params={
        elemapid: this.mapid,
        userid:this.elemapInfo.userid,
        type:2,
        recordcontent:title
      }
      this.$api.addRecord(params,res=>{
        ////console.log(res)
        if(res.errCode==0){
          // this.$router.push({name:"mapList"})
        }else{
          this.$message({
            message:"操作记录新增失败，请重试！",
            type:"warning"
          })
        }
      })
    },
    //新增告警记录 
    addWarn(content,normalstatus,abnormalstatus,id){
      var params={
        elemapid: this.mapid,
        userid:this.elemapInfo.userid,
        updatecontent:content,
        normalstatus:normalstatus,
        abnormalstatus:abnormalstatus,
        componentid:id
      }
      this.$api.addWarn(params,res=>{
        ////console.log("新增告警",res)
      })
    },
    //修改告警记录  将有标准状态的设备切换到正常的位置
    updateWarn(elemapid,componentid){
      this.$api.updateWarn({elemapid,componentid},res=>{
        //console.log("修改告警记录",res)
      })
    },
    //新增预演记录
    addSimulateRecord(){
      var params=this.simulateInfo;
      params.content=JSON.stringify(this.simulateContent);
      params.mapName=this.elemapInfo.title;
      ////console.log(params)
      this.$api.addSimulationRecord(params,res=>{
        ////console.log(res)
        if(res.errCode==0){
          this.$router.push({name:"mapList"})
        }else{
          this.$message({
            message:"预演记录新增失败，请重试！",
            type:"warning"
          })
        }
      })
    },
    //模拟预演标题确认
    saveTitle(){
      this.addSimulateRecord()
    },
    //save按钮做区分，新增模拟图和修改模拟图需要编辑标题，其他操作则不需要
    mySave(){

      if(this.type==1 || !this.type){
          this.dialogFormVisible=true
      }else{
        // for (var i = 0; i < this.diagram.model.nodeDataArray.length; i++) {
        //   if (this.diagram.model.nodeDataArray[i].key == this.clickn.key) {
        //     this.diagram.model.nodeDataArray[i].logicOn = this.clickn.logicOn;
        //     this.diagram.model.nodeDataArray[i].logicOff = this.clickn.logicOff;
        //   }
        // }
        var diagrammodel = this.diagram.model.toJson();
        var dm = JSON.parse(diagrammodel);
        if(this.type==3){
          // this.dialogTitle="操作模拟图"
          // let params = {
          //   id: this.mapid,
          //   reviserid: this.elemapInfo.userid,
          //   reviserName:this.elemapInfo.userName,
          //   title:this.elemapInfo.title,
          //   type:this.mapType,
          //   nodedata: JSON.stringify(dm.nodeDataArray),
          //   linkdata: JSON.stringify(dm.linkDataArray)
          // };
          // ////console.log(dm.nodeDataArray)
          // this.$api.updateMap(params, res => {
          //   ////console.log(res, "resres");
          //   if (res.errCode == 0) {
          //     this.$message({
          //       message: "操作成功",
          //       type: "success"
          //     });
          //     this.$router.push({name:'mapList'})
          //   }
          // });
          this.$router.push({name:'mapList'})
        }else if(this.type==2){
          //模拟预演记录增加
          // this.addSimulateRecord()
          // this.myDialogVisible=true;

        }else if(this.type==4){
          ////console.log("添加逻辑条件")
          let params = {
            id: this.mapid,
            reviserid: this.elemapInfo.userid,
            reviserName:this.elemapInfo.userName,
            title:this.elemapInfo.title,
            type:this.mapType,
            //nodedata: JSON.stringify(dm.nodeDataArray),
            linkdata: JSON.stringify(dm.linkDataArray)
          };
          this.$api.updateMap(params, res => {
            if (res.errCode == 0) {
              this.$message({
                message: "逻辑条件添加成功",
                type: "success"
              });
              this.$router.push({name:'mapList'})
            }
          });
        }
      }
    },
    linkClick(){
      this.infoshow=false;
    },
    //选项变化 切换模拟图
    changeMap(){
      this.mapid=this.title[1]
      ////console.log(this.title)
      if(this.type==2){
        ////console.log("模拟预演",JSON.parse(this.allMapInfo[0].nodedata))
        var arr=this.allMapInfoBySimulate;
        arr.forEach(v=>{
          if(v.id==this.title[1]){
            if(v.nodedata){
              this.modelData.nodeDataArray = JSON.parse(v.nodedata);
              this.myData = JSON.parse(v.nodedata);
            }
            if(v.linkdata){
              this.modelData.linkDataArray = JSON.parse(v.linkdata);
            }
          this.elemapInfo.title = v.title
           this.diagram.model = go.Model.fromJson(this.modelData);
          //this.modelData = this.diagram.model.toJson();
          this.mapType=v.type
          }
        })
      }else{
        this.getmapInfo()
      }
    },
    //获取模拟图信息
    getmapInfo() {
        let params = {id: this.mapid};
        this.$api.getMapInfo(params, res => {
            if(res.data.list[0].linkdata){
              this.modelData.linkDataArray = JSON.parse(res.data.list[0].linkdata);
            }
            this.elemapInfo.title = res.data.list[0].title
            this.mapType=res.data.list[0].type
            let mparams={mapid:this.mapid}
            console.log("22222222")
            this.$api.getcomponentlist(mparams,res=>{
              for (var i=0;i<res.data.list.length;i++){
                      if( res.data.list[i].items && !(res.data.list[i].items instanceof Array)){
                        res.data.list[i].items=JSON.parse(res.data.list[i].items)
                      }
                  }
                    //console.log(res,'resres')
                    this.modelData.nodeDataArray = res.data.list;
                    this.myData = res.data.list;
                    this.diagram.model = go.Model.fromJson(this.modelData);
                    })
                });
    },
    //根据mapids获取模拟图信息   点击节点的时候调用
    getmapidsInfo(ids) {
      // console.log("调用1次")
        let params = {
          id: ids
        };
        this.$api.getMapInfo(params, res => {
          this.mapList=res.data.list 
        });
        this.mapList.forEach(item=>{
          console.log("1111")
          this.$api.getcomponentlist({mapid:item.id},res=>{
             for (var i=0;i<res.data.list.length;i++){
                    if(res.data.list[i].items && !(res.data.list[i].items instanceof Array)){
                      res.data.list[i].items=JSON.parse(res.data.list[i].items)
                    }
              }
            item.nodedata=JSON.stringify(res.data.list)
          })
        })
    },
    //获取所有模拟图信息 模拟预演的时候使用
    getMapBySimulate(){
      this.$api.getMapInfo({}, res => {
          this.mapList=res.data.list
          this.mapList.forEach((item)=>{
            this.$api.getcomponentlist({mapid:item.id},res=>{
              if(res.errCode==0){
                item.nodedata=JSON.stringify(res.data.list)
              }
            })
          })
          this.allmapInfolist=Object.assign([],this.mapList)
          this.$api.getAllMapType({},res=>{
            this.titles=[]
            this.mapTypes=[]
            res.data.forEach(item=>{
              var obj={}
              obj.value=item.id;
              obj.label=item.name
              obj.children=[]
              this.titles.push(obj)
              this.mapTypes.push(obj)
            })
            this.mapList.forEach((item)=>{
              this.titles.forEach((item2)=>{
                if(item.type==item2.value){
                  var cobj={}
                  cobj.value=item.id;
                  cobj.label=item.title
                  item2.children.push(cobj)
                }
              })
            })
            this.infoOptions=Object.assign([],this.titles)
        })
          this.allMapInfoBySimulate=Object.assign([],this.allmapInfolist)
        });
    },
    //获取模拟图信息
    getmapElement() {
        this.$api.getMapInfo({}, res => {
          this.mapList=res.data.list
          this.mapList.forEach((item)=>{
            this.$api.getcomponentlist({mapid:item.id},res=>{
              if(res.errCode==0){
                item.nodedata=JSON.stringify(res.data.list)
              }
            })
          })
          this.allmapInfolist=Object.assign([],this.mapList)
          this.$api.getAllMapType({},res=>{
            this.titles=[]
            this.mapTypes=[]
            res.data.forEach(item=>{
              var obj={}
              obj.value=item.id;
              obj.label=item.name
              obj.children=[]
              this.titles.push(obj)
              this.mapTypes.push(obj)
            })
            ////console.log(this.mapTypes,'mapTypes')
            this.mapList.forEach((item)=>{
              this.titles.forEach((item2)=>{
                if(item.type==item2.value){
                  var cobj={}
                  cobj.value=item.id;
                  cobj.label=item.title
                  //cobj.children=[]
                  item2.children.push(cobj)
                }
              })
            })
            this.infoOptions=Object.assign([],this.titles)
        })
          this.allMapInfo=Object.assign([],this.allmapInfolist)
        });
    },
    change() {
      this.onchange=true;
   
      // this.logicArr=arr
      // ////console.log(this.logicArr,'logicArr')
    },
    changeOff() {
      this.offchange=true;
      
    },
    changeChoice2(){
      this.choice2change=true;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    download() {
      // 将图片的src属性作为URL地址
      var img = this.diagram.makeImage({
        scale: 1,
        background: "#fff"
      });

      var url = img.src;
      var a = document.createElement("a");
      var event = new MouseEvent("click");
      a.download = "流程图";
      a.href = url;
      a.dispatchEvent(event);
    },
    save(formName) {
          for (var i = 0; i < this.diagram.model.nodeDataArray.length; i++) {
            if (this.diagram.model.nodeDataArray[i].key == this.clickn.key) {
              this.diagram.model.nodeDataArray[i].logicOn = this.clickn.logicOn;
              this.diagram.model.nodeDataArray[i].logicOff = this.clickn.logicOff;
            }
          }
            var diagrammodel = this.diagram.model.toJson();
            //console.log("555555",this.diagram.model)
            var dm = JSON.parse(diagrammodel);
            // //console.log("转换",dm.nodeDataArray)
            dm.nodeDataArray.forEach((item)=>{
              if(item.logicOn instanceof Array){
                item.logicOn=JSON.stringify(item.logicOn)
              }
              if(item.logicOff instanceof Array){
                item.logicOff=JSON.stringify(item.logicOff)
              }
              if(item.logicChoice2 instanceof Array){
                item.logicChoice2=JSON.stringify(item.logicChoice2)
              }
              if(item.url instanceof Array){
                item.url=JSON.stringify(item.url)
              }
              if(item.items instanceof Array){
                item.items=JSON.stringify(item.items)
              }
               if(item.items instanceof Array){
                item.items=JSON.stringify(item.items)
              }
            })
          
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.dialogFormVisible = false;
              //编辑
              if (this.type==1) {
                this.dialogTitle="修改模拟图"
                let params = {
                  id: this.mapid,
                  title: this.elemapInfo.title,
                  reviserid: this.elemapInfo.userid,
                  reviserName:this.elemapInfo.userName,
                  type:this.mapType,
                  nodedata: JSON.stringify(dm.nodeDataArray),
                  linkdata: JSON.stringify(dm.linkDataArray)
                };
                this.$api.updateMap(params, res => {
                  ////console.log(res, "resres");
                  if (res.errCode == 0) {
                    this.$message({
                      message: "修改成功",
                      type: "success"
                    });
                    this.$router.push({name:"mapList"})
                    //添加修改记录
                    this.addUpdateRecord(dm.nodeDataArray)
                  }
                });
              } else if (!this.type){
                let params = {
                  title: this.elemapInfo.title,
                  userid: this.elemapInfo.userid,
                  userName:this.elemapInfo.userName,
                  type:this.mapType,
                  nodedata: JSON.stringify(dm.nodeDataArray),
                  linkdata: JSON.stringify(dm.linkDataArray)
                };
                //新增模拟图
                //console.log(params)
                this.$api.addMap(params, res => {
                  ////console.log(res, "resres");
                  if (res.errCode == 0) {
                    this.$message({
                      message: "创建成功",
                      type: "success"
                    });
                    this.$router.push({name:"mapList"})
                  }
                });
              
              }
              this.modelData = this.diagram.model.toJson();
              //localStorage.setItem("diagramData", this.modelData);
              this.diagram.isModified = false;
            } else {
              return false;
            }
          });
      
    },
    //按照属性拆分数组
    classify(arr){
      ////console.log(arr,'arrarr')
      var logicSignArr=[]
      for (var i=0;i<arr.length;i++){
        if(logicSignArr.indexOf(arr[i].logicSign)===-1){
          logicSignArr.push(arr[i].logicSign)
        }
      }
      // let obj = {}
      // arr.map(v => {
      //   obj[v.logicSign] = 0  
      // })
      // ////console.log(obj,'objobj')
      // let timeArr = Object.keys(obj)
      ////console.log(logicSignArr,'logicSignArr')
      let result = logicSignArr.map(v => {
        return {
          data: arr.filter(_v => v == _v.logicSign)
        }
      })
      ////console.log(result,'result')
      return result
    },
    //逻辑验证
    logic(key){
      var _this = this;
      this.operRecord=[]
      var node = this.diagram.model.findNodeDataForKey(key); //首先拿到这个节点的对象
      // //console.log("拿到该节点的关闭逻辑数据",node.logicOff)
      //切换到status0状态
      // //console.log("逻辑条件",_this.offlogic,node.logicOff)
      if(_this.currentStatus==0&&node.logicOff!='[]'){
        //console.log("切换到0")
        _this.statusLogic(node.logicOff,_this.offlogic)
      }
      //切换到status1的状态
      if(_this.currentStatus==1&&node.logicOn!='[]'){
       _this.statusLogic(node.logicOn,_this.onlogic)
       //console.log("切换到1")
      }
      //切换到status2的状态
      if(_this.currentStatus==2&&node.logicChoice2!='[]'){
        _this.statusLogic(node.logicChoice2,_this.choice2logic)
        //console.log("切换到2")
      }
      //弹框数据处理
      ////console.log(this.operRecord,'opopop')
      if(this.operRecord.length>0){ 
        var newOperrecord=[]
        for(var item of this.operRecord){
          for(var citem of item){
            newOperrecord.push(citem)
          }  
        }
        this.operRecord=newOperrecord
        this.operationDialogVisible=true
        return false
      }else{
        return true
      }
    },
    //按照切换状态处理相应逻辑数组
    statusLogic(arr,logicArr){
      //console.log("逻辑条件数组",arr)
      let _this=this
        if(arr&&arr.length>0){
          var lsign=[]
          for (var item of arr){
              if(lsign.indexOf(item.logicSign) == -1 ) {
                lsign.push(item.logicSign)
              }
          }
          this.wrongIndex=[]
          var ok=[]
          var resultArr=this.classify(arr)
          //条件全要满足
          // //console.log(lsign)
          if(lsign.length==1){//只有一个条件  且的关系
            
            for(var i=0;i<arr.length;i++){
              if(this.mapid==arr[i].mapid){//逻辑条件在本图之中
              //console.log("走上面")
                if(arr[i].status!==_this.getNodeobject(arr[i].key)){
                  // //console.log(arr[i],_this.getNodeobject(arr[i].key))
                  ok.push('false')
                  this.operRecord=logicArr
                } else{
                        ok.push('true')
                      }
              }else{//只有一个条件  在另外一张图 
              //console.log("走下面",i)
                //console.log(_this.getmapidStatus(arr[i].mapid,arr[i].key),"逻辑条件所在图的设备现在的status")
                //console.log(arr[i].status,'逻辑条件的status')
                if(_this.getmapidStatus(arr[i].mapid,arr[i].key)!=arr[i].status){
                  ok.push('false')
                   _this.operRecord=logicArr
                }else{
                        ok.push('true')
                      }  
              }
            }
          }else if(lsign.length>1){//条件只要满足一条就行了  或关系
             //for(var i=0;i<resultArr.length;i++){
               var k2=0
               while(k2<resultArr.length){
                 
                 for(var j=0;j<resultArr[k2].data.length;j++){
                    if(this.mapid==resultArr[k2].data[j].mapid){
                      if(resultArr[k2].data[j].status!==_this.getNodeobject(resultArr[k2].data[j].key)){
                        ok.push('false')
                        //break;
                      }else{
                        ok.push('true')
                      }
                    }else{
                      // //console.log(_this.getmapidStatus(resultArr[k2].data[j].mapid,resultArr[k2].data[j].key),'9999999')
                      //console.log("走这里来了")
                        if(_this.getmapidStatus(resultArr[k2].data[j].mapid,resultArr[k2].data[j].key)!==resultArr[k2].data[j].status){
                          ok.push('false')
                          //break;
                        } else{
                        ok.push('true')
                      }
                    }
                  }
                  k2++
               }
              // ////console.log(logicArr,'logicArr')
          }  
              
              ok.forEach((item,index)=>{
                if(item=='false'){
                  this.wrongIndex.push(index)
                }
              })
              var li=0
              var lc=''
              var len=0
              for(li=0;li<resultArr.length;li++){
                //截取或者条件  各个条件的满足情况
                if(li==0){
                  lc= ok.slice(li,resultArr[li].data.length)
                }else{
                  for(var k=0;k<li;k++){
                    len += resultArr[k].data.length
                  }
                  lc=ok.slice(len,len+resultArr[li].data.length)
                }
                if(lc.includes('false')){ //或条件里，有false则往下走
                  continue
                }else{  //有某一条满足了，循环跳出
                  break ;
                }
              }
              if(li==resultArr.length){  //长度相等，代表没有任何一条满足条件
                this.operRecord=logicArr
              }
            }
            
    },
    //添加逻辑
    addLogic(){
      let _this=this
      if(this.onchange){
        if(this.clickn.logicOn&&this.clickn.logicOn.length>0){
          this.logicSignon=this.clickn.logicOn[this.clickn.logicOn.length-1].logicSign+1
        }else{
          this.logicSignon=0
        }
      }
      if(this.offchange){
        if(this.clickn.logicOff&&this.clickn.logicOff.length>0){
          this.logicSignoff=this.clickn.logicOff[this.clickn.logicOff.length-1].logicSign+1
        }else{
          this.logicSignoff=0
        }
      }
       if(this.choice2change){
        if(this.clickn.logicChoice2&&this.clickn.logicChoice2.length>0){
          this.logicSignchoice2=this.clickn.logicChoice2[this.clickn.logicChoice2.length-1].logicSign+1
        }else{
          this.logicSignchoice2=0
        }
      }
      //开逻辑显示
      var a=[]
      for(var i=0;i<_this.$refs["cascader"].presentTags.length;i++){
        var aobj={}
        aobj.value=_this.$refs["cascader"].presentTags[i].text
        aobj.logicSign=_this.logicSignon
        //a.push(this.$refs["cascader"].presentTags[i].text)
        a.push(aobj)
      }
      
      if(a.length>0){
        this.onlogic.push(a)
        // this.onlogic.push(a.join(';'))
      }
      //关逻辑显示
      var b=[]
      for(var j=0;j<_this.$refs["cascaderoff"].presentTags.length;j++){
        var bobj={}
        bobj.value=_this.$refs["cascaderoff"].presentTags[j].text
        bobj.logicSign=_this.logicSignoff
        //b.push(this.$refs["cascaderoff"].presentTags[j].text)
        b.push(bobj)
      }
     
      if(b.length>0){
        //this.offlogic.push(b.join(';'))
        this.offlogic.push(b)
      }
      
      //choice2逻辑显示
      if(this.moreChoice){
         var c=[]
        for(var k=0;k<_this.$refs["cascaderChoice2"].presentTags.length;k++){
          var cobj={}
          cobj.value=_this.$refs["cascaderChoice2"].presentTags[k].text
          cobj.logicSign=_this.logicSignchoice2
          c.push(cobj)
        }
        if(c.length>0){
          this.choice2logic.push(c)
        }
        ////console.log(this.choice2logic,'choice2logic')
      }
      //增加开逻辑
      var onnodesObj = this.$refs["cascader"].getCheckedNodes();
      ////console.log(onnodesObj,'onnodesObj')
      var onarr = [];
      for (var i = 0; i < onnodesObj.length; i++) {
        var onobject = {};
        onobject.mapid = onnodesObj[i].path[1];
        onobject.pathLabels = onnodesObj[i].pathLabels;
        onobject.key = onnodesObj[i].parent.value;
        onobject.title = onnodesObj[i].parent.label;
        onobject.status = onnodesObj[i].value;
        onobject.label = onnodesObj[i].label;
        onobject.logicSign = this.logicSignon
        onarr.push(onobject);
      }
      var onar=[]
      for (var item of this.clickn.logicOn){
          if(onar.indexOf(item.key) == -1 ) {
            onar.push(item.key)
          }
      }
      for(var j=0;j<onarr.length;j++){
         //if(onar.indexOf(onarr[j].key)==-1){
            this.clickn.logicOn.push(onarr[j]);
         //}
      }
      //增加关逻辑
      var nodesObj = this.$refs["cascaderoff"].getCheckedNodes();
      var arr2 = [];
      for (var i = 0; i < nodesObj.length; i++) {
        var object = {};
        object.mapid = nodesObj[i].path[1];
        object.pathLabels = nodesObj[i].pathLabels;
        object.key = nodesObj[i].parent.value;
        object.title = nodesObj[i].parent.label;
        object.status = nodesObj[i].value;
        object.label = nodesObj[i].label;
        object.logicSign = this.logicSignoff
        arr2.push(object);
      }
      //////console.log(arr2,'arr2arr2')
      var ar=[]
      for (var item of this.clickn.logicOff){
          if(ar.indexOf(item.key) == -1 ) {
            ar.push(item.key)
          }
      }
      //////console.log(ar,'arararar')
      for(var j=0;j<arr2.length;j++){
         //if(ar.indexOf(arr2[j].key)==-1){
            this.clickn.logicOff.push(arr2[j]);

         //}
      }
      //////console.log(this.clickn.logicOff, "logicOff");
      //choice2逻辑
      if(this.moreChoice){
        var choice2Obj = this.$refs["cascaderChoice2"].getCheckedNodes();
        var choiceArr = [];
        for (var i = 0; i < choice2Obj.length; i++) {
          var choiceobj = {};
          choiceobj.mapid = choice2Obj[i].path[1];
          choiceobj.pathLabels = choice2Obj[i].pathLabels;
          choiceobj.key = choice2Obj[i].parent.value;
          choiceobj.title = choice2Obj[i].parent.label;
          choiceobj.status = choice2Obj[i].value;
          choiceobj.label = choice2Obj[i].label;
          choiceobj.logicSign = this.logicSignchoice2
          choiceArr.push(choiceobj);
        }
        var choiceAr=[]
        for (var item of this.clickn.logicChoice2){
            if(choiceAr.indexOf(item.key) == -1 ) {
              choiceAr.push(item.key)
            }
        }
        for(var j=0;j<choiceArr.length;j++){
          //if(choiceAr.indexOf(choiceArr[j].key)==-1){
              this.clickn.logicChoice2.push(choiceArr[j]);
          //}
        }
      }
      
      
      this.$refs["cascader"].panel.clearCheckedNodes()
      this.$refs["cascaderoff"].panel.clearCheckedNodes()
      
      this.onchange=false;
      this.offchange=false;
      if(this.moreChoice){
        this.$refs["cascaderChoice2"].panel.clearCheckedNodes()
        this.choice2change=false;
      }
      
      var nparams=JSON.parse(JSON.stringify(_this.clickn))
      if(nparams.logicOn instanceof Array){
        nparams.logicOn=JSON.stringify(nparams.logicOn)
      }
      if(nparams.logicOff instanceof Array){
        nparams.logicOff=JSON.stringify(nparams.logicOff)
      }
      if(nparams.logicChoice2 instanceof Array){
        nparams.logicChoice2=JSON.stringify(nparams.logicChoice2)
      }
      if(nparams.url instanceof Array){
        nparams.url=JSON.stringify(nparams.url)
      }
      var cparams={
        nodedata:nparams
      }
      ////console.log(cparams,'cpcpcpcpcpcp')
      this.$api.changecom(cparams,res=>{
        if(res.errCode==0){
          // this.$message({
          //     message: "逻辑条件添加成功",
          //     type: "success"
          //   });
        }
      })
    },
    //清空逻辑
    clearallLogic(){
      this.clearLogic()
      this.clearoffLogic()
      
      this.choice2logic=[];
      this.logicValueChoice2=[];
      this.clickn.logicChoice2=[];
      this.logicSignchoice2=1
    },
    //清空开逻辑
    clearLogic(){
      this.onlogic=[];
      this.logicValue=[];
      this.clickn.logicOn=[];
      this.logicSignon=1;
      
    },
    //清空关逻辑
    clearoffLogic(){
      this.offlogic=[];
      this.logicValueOff=[];
      this.clickn.logicOff=[];
      this.logicSignoff=1
    },
    //获取指定模拟图指定key的状态
    getmapidStatus(id,key){
      
        if(this.type==2){
          var statusArr=this.allMapInfoBySimulate.filter((item)=>{
            return item.id==id
          })
          //////console.log(JSON.parse(statusArr[0].nodedata),'eeeeeee')
          var sArr=JSON.parse(statusArr[0].nodedata).filter((item)=>{
            return item.id==key
          })
          return sArr[0].status
        }else{
          
          var statusArr=this.allmapInfolist.filter((item)=>{
            return item.id==id
          })
          // //console.log(JSON.parse(statusArr[0].nodedata),'hhhhhhhh')
          var sArr=JSON.parse(statusArr[0].nodedata).filter((item)=>{
            return item.id==key
          })
          // //console.log(sArr[0].status,'需要比对设备的status')
          return sArr[0].status
        }

    },
    //获取指定节点的对象  本图的
    getNodeobject(key){
      //key是元器件的id
      if(this.type=="2"){
        var status;        
        this.allMapInfoBySimulate.forEach(v=>{
            JSON.parse(v.nodedata).forEach(o=>{
              if(o.id==key){
                status=o.status
              }
            })
        })
        return status
      }else{
        var ar=this.modelData.nodeDataArray
        // //console.log("88888",ar)
          for(var i=0;i<ar.length;i++){
            if(ar[i].id==key){
              return ar[i].status
            }
          }
      }
      
    },
    titleInput(){
      var node = this.diagram.model.findNodeDataForKey(this.clickn.key); //首先拿到这个节点的对象
      this.diagram.model.setDataProperty(node, "title", this.infoTitle);
      this.diagram.model.setDataProperty(node, "fullName", this.fullName);
    },
    describeInput(){
      var node = this.diagram.model.findNodeDataForKey(this.click.key); //首先拿到这个节点的对象
      this.diagram.model.setDataProperty(node, "describle", this.describeText);
    },
    radioInput(num){
      var node = this.diagram.model.findNodeDataForKey(this.clickn.key); //首先拿到这个节点的对象
      ////console.log(node,'nnnnnnnnnnnnnnnnnnnn')
      ////console.log(num,'numnum')
      if(num==1){
        ////console.log(this.currentChoice1,'ccccccccccccc1')
        this.diagram.model.setDataProperty(node, "option1", this.currentChoice1);
      } if(num==0){
        this.diagram.model.setDataProperty(node, "option0", this.currentChoice0);
      } if(num==2){
        this.diagram.model.setDataProperty(node, "option2", this.currentChoice2);
      }if(num==3){ //只有两种状态 开
        this.diagram.model.setDataProperty(node, "stateon", this.stateon);
      } if(num==4){//只有两种状态 关
        this.diagram.model.setDataProperty(node, "stateoff", this.stateoff);
      }
      
    },
    //添加描述
    addDescribe(type,obj){
      if(type==2){
        this.describeDisable=true
        this.isaddLogic = true;
        this.uploadDisable=true;
      }else{
        this.describeDisable=false
        this.isaddLogic = false;
        this.uploadDisable=false;
      }
      this.isaddDescribe=true
      ////console.log(obj.part.data,'objobj')
      this.click = obj.part.data
      this.rightclick = obj.part.data

      if(this.rightclick.url){
        if(this.rightclick.url instanceof Array){
          this.rightclick.url=this.rightclick.url
        }else{
          this.rightclick.url=JSON.parse(this.rightclick.url)
        }
        this.fileList=this.rightclick.url
      }else{
         this.rightclick.url=[]
         this.fileList=[]
      }
      
      this.infoTitle=this.rightclick.title
      this.fullName=this.rightclick.fullName
      if(!this.rightclick.describle){
        this.rightclick.describle=""
        this.describeText=""
      }else{
        this.describeText=this.rightclick.describle
      }
      this.infoshow=true
      this.operate=false
      this.describeShow=true
      this.standardStatus=false;
      this.titleshow = false; 
      //this.isaddLogic = false;
      this.clickDiagramnode = false;
      
    },
    //面板确定按钮
    defineChange(){
      console.log(this.type)
      let _this=this
      this.infoshow=false
      if(this.isaddDescribe){ //添加描述与上传图片
        this.describeInput()//修改图上设备的描述
        this.$refs.upload.submit();
        this.updateCompoent();
      }else{
        this.titleInput()//修改图上设备的title
        if(this.moreChoice){
          _this.radioInput(0)
          _this.radioInput(1)
          _this.radioInput(2)
        }else{ //只有两种状态的开关
          _this.radioInput(3)//修改单选框的文本
          _this.radioInput(4)
        }
        if(this.type==4){
          this.changeRadio()//修改标准状态
        }
        var data = this.diagram.model.findNodeDataForKey(this.clickn.key);
        console.log("88888",data)
        if(data.type==2){
            data.items[0].width=parseInt(this.imgWidth) || data.items[0].width;
            data.items[0].height=parseInt(this.imgHeight) || data.items[0].height;
            this.imgWidth="";
            this.imgHeight="";
        }
        // if(this.X&&this.Y){
        //   data.loc=`${this.X} ${this.Y}`
        //   this.loc=`${this.X} ${this.Y}`
        // }
        if(this.usertype!=1){
          if(this.logic(this.clickn.key)){
            this.changeCurrentStatus()//修改图上设备的状态
          }
        if(this.type==3 || this.type==2 || this.type==1){
          if(this.logic(this.clickn.key)){
            this.doubleClickAddRecordForPass(data)
            //验证通过，直接修改数据库，修改设备的状态
            if(this.type==2){//模拟预演，需要修改本地的数据
              var map=this.allMapInfoBySimulate;
              var drawItems=[{ height:110,width:40,source:this.png33 }]
              var draw2Items=[{ height:100, width:40, source:this.png34 }]
              map.forEach(v=>{
                if(v.id==this.mapid){
                  var arr=JSON.parse(v.nodedata);
                  arr.forEach(o=>{
                    if(o.id==data.id){
                      o.status=data.status;
                      if(o.category=="切换开关"){
                        if(this.currentStatus=="1"){ o.angle=300;}
                        if(this.currentStatus=="0"){ o.angle=0;}
                        if(this.currentStatus=="2"){ o.angle=60;}
                      }else if(o.category.includes("双头开关")){
                        if(this.currentStatus=="1"){ o.category="双头开关";}
                        if(this.currentStatus=="0"){ o.category="双头开关2";}
                        if(this.currentStatus=="2"){ o.category="双头开关3";}
                      }else{
                        if(this.currentStatus=="1"){
                          if(o.category=="接地桩"){
                            if(this.infoTitle==""){o.title=""}else{o.title=this.infoTitle}
                            o.stroke=this.color
                          }
                          if(o.category=="闸刀2"){o.category="闸刀";o.angle=90;o.stroke=this.color;}
                          if(o.category=="抽屉2"){o.category="抽屉";o.items=drawItems;}
                          if(o.category.includes("阀门")||o.category.includes("开关")){o.fill=this.color;o.stroke=this.color;}
                        }else if(this.currentStatus=="0"){
                          if(o.category=="接地桩"){o.title=""; o.stroke=this.offcolor;}
                          if(o.category=="闸刀"){o.category="闸刀2";o.angle=0;o.stroke=this.offcolor;}
                          if(o.category=="抽屉"){o.category="抽屉2";o.items=draw2Items;}
                          if(o.category.includes("阀门")||o.category.includes("开关")){o.fill=this.offcolor;o.stroke=this.offcolor;}
                        }
                      }
                      v.nodedata=JSON.stringify(arr)
                    }
                  })
                  // ////console.log("修改后的nodedata",JSON.parse(v.nodedata),JSON.parse(this.allMapInfo[0].nodedata),this.allMapInfo)
                }
              })
            }else{
              this.updateCompoent();
             
            }
          }else{
            ////console.log("验证不通过777777",data)
            this.doubleClickAddRecordForReject(data)
          }
        }
        }else{
          this.changeCurrentStatus()
          this.updateCompoent();
        }
        if(this.type==3){//操作的时候 修改状态后 重新获取数据
          this.getmapElement()//重新获取一下 更新后的所有数据
        }
      }
    },
    //取消按钮
    cancel(){
      this.infoshow=false
    },
    //操作设备 直接修改数据库
    updateCompoent(){
      let _this=this

      var nparams=JSON.parse(JSON.stringify(_this.clickn))
      if(nparams.logicOn instanceof Array){
        nparams.logicOn=JSON.stringify(nparams.logicOn)
      }
      if(nparams.logicOff instanceof Array){
        nparams.logicOff=JSON.stringify(nparams.logicOff)
      }
      if(nparams.logicChoice2 instanceof Array){
        nparams.logicChoice2=JSON.stringify(nparams.logicChoice2)
      }
      if(nparams.url instanceof Array){
        nparams.url=JSON.stringify(nparams.url)
      }
       if(nparams.items instanceof Array){
        nparams.items=JSON.stringify(nparams.items)
      }
      let params={
        nodedata:nparams
      }
      if(this.clickn.id){
        this.$api.changecom(params,res=>{
            if (res.errCode == 0) {
              this.$message({
                message: "修改成功",
                type: "success"
              });
            }
        })
      }else{
        var choseNode=[]
        choseNode.push(nparams)
        for(var i=0;i<choseNode.length;i++){
          if(choseNode[i].items instanceof Array){
            choseNode[i].items=JSON.stringify(choseNode[i].items)
          }
        }
        if(this.mapid){
          let aparams={
            nodedata:JSON.stringify(choseNode),
            mapid:this.mapid
          }
          this.$api.addcom(aparams,res=>{
              if (res.errCode == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
              }
          })
        }
      }
      
    },
    //标准状态
    changeRadio(){
      this.clickn.state=this.state
    },
    //当前状态
    changeCurrentStatus(){
      var drawItems=[{ height:110,width:40,source:this.png33 }]
      var draw2Items=[{ height:100, width:40, source:this.png34 }]

      var node = this.diagram.model.findNodeDataForKey(this.clickn.key); //首先拿到这个节点的对象
      
      this.diagram.model.setDataProperty(node, "state", this.state);
      //if(this.logic(this.clickn.key)){
        if(node.category=="切换开关"){
            if (this.currentStatus == "1") {
              this.diagram.model.setDataProperty(node, "angle", 300); //然后对这个对象的属性进行更改
              this.diagram.model.setDataProperty(node, "status", 1);
            }else if (this.currentStatus == "0") {
              this.diagram.model.setDataProperty(node, "angle", 0);
              this.diagram.model.setDataProperty(node, "status", 0);
            }else if (this.currentStatus == "2") {
              this.diagram.model.setDataProperty(node, "angle", 60);
              this.diagram.model.setDataProperty(node, "status", 2);
            }
        }else if(node.category=="双头开关"||node.category=="双头开关2"||node.category=="双头开关3"){
          if(this.currentStatus == "1"){
            this.diagram.model.setDataProperty(node, "category", "双头开关");
            this.diagram.model.setDataProperty(node, "status", 1);
          }if(this.currentStatus == "0"){
            this.diagram.model.setDataProperty(node, "category", "双头开关2");
            this.diagram.model.setDataProperty(node, "status", 0);
          }if(this.currentStatus == "2"){
            this.diagram.model.setDataProperty(node, "category", "双头开关3");
            this.diagram.model.setDataProperty(node, "status", 2);
          }
        }else{
        if(this.currentStatus=="1"){
             if(node.category=="接地桩"){
               this.isGround=true
              //  if(this.infoTitle==""){
              //    this.diagram.model.setDataProperty(node, "title", "请输入"); 
              //  }else{
                 this.diagram.model.setDataProperty(node, "title", this.infoTitle); 
                 this.diagram.model.setDataProperty(node, "connect", this.groundValue); 
              //  }
                this.diagram.model.setDataProperty(node, "stroke", this.color);
                this.diagram.model.setDataProperty(node, "status", 1); 
              }else if(node.category=="闸刀2"){
                this.diagram.model.setDataProperty(node, "status", 1);
                this.diagram.model.setDataProperty(node, "category", "闸刀");
                this.diagram.model.setDataProperty(node, "angle", 90);
                this.diagram.model.setDataProperty(node, "stroke", this.color);
              }else if(node.category=="抽屉2"){
                this.diagram.model.setDataProperty(node, "items", drawItems); 
                this.diagram.model.setDataProperty(node, "category", "抽屉"); 
                this.diagram.model.setDataProperty(node, "status", 1); 
              }else{
                this.diagram.model.setDataProperty(node, "fill", this.color);
                this.diagram.model.setDataProperty(node, "stroke", this.color);
                this.diagram.model.setDataProperty(node, "status", 1);
              }
        } if(this.currentStatus=="0"){
          
             if(node.category=="接地桩"){
                this.isGround=false;
                this.diagram.model.setDataProperty(node, "connect", ""); 
                // this.diagram.model.setDataProperty(node, "title", ""); 
                this.diagram.model.setDataProperty(node, "stroke", this.offcolor);
                this.diagram.model.setDataProperty(node, "status", 0); 
              }else if(node.category=="闸刀"){
                this.diagram.model.setDataProperty(node, "status", 0);
                this.diagram.model.setDataProperty(node, "category", "闸刀2");
                this.diagram.model.setDataProperty(node, "angle", 0);
                this.diagram.model.setDataProperty(node, "stroke", this.offcolor);
              }else if(node.category=="抽屉"){    
                this.diagram.model.setDataProperty(node, "items", draw2Items); 
                this.diagram.model.setDataProperty(node, "category", "抽屉2"); 
                this.diagram.model.setDataProperty(node, "status", 0); 
              }else{
                this.diagram.model.setDataProperty(node, "fill", this.offcolor);
                this.diagram.model.setDataProperty(node, "stroke", this.offcolor);
                this.diagram.model.setDataProperty(node, "status", 0);
              }
        }
      }
      //}
    },
    dialogClose(){
      //this.state=this.state=="1"?"0":"1"
    },
    //删除开逻辑
    delLogicon(item,index) {
      this.onlogic.splice(index, 1);
      var arr = this.clickn.logicOn.filter((it,ind)=>{
        return it.logicSign!=item[0].logicSign
      })
      this.clickn.logicOn=arr
    },
    //删除关逻辑
    delLogicoff(item,index) {
      this.offlogic.splice(index, 1);
      var arr = this.clickn.logicOff.filter((it,ind)=>{
        return it.logicSign!=item[0].logicSign
      })
      this.clickn.logicOff=arr
    },
    //删除choice2逻辑
    delLogic2(item,index){
      this.choice2logic.splice(index, 1);
      var arr = this.clickn.logicChoice2.filter((it,ind)=>{
        return it.logicSign!=item[0].logicSign
      })
      this.clickn.logicChoice2=arr
    },
    load() {
      // var diagramData = localStorage.getItem("diagramData");
      // if (diagramData) {
      //   this.modelData = diagramData;
      //   this.diagram.model = go.Model.fromJson(diagramData);
      // } else {
      this.diagram.model = go.Model.fromJson(this.modelData);
      this.modelData = this.diagram.model.toJson();
     //}
    },
    clear() {
      localStorage.clear();
      this.diagram.model.nodeDataArray = [];
      this.diagram.model.linkDataArray = [];
      this.modelData = this.diagram.model.toJson();
    },
    //点击节点
    clickNode(e, obj) {
      this.myType=obj.part.data.type
      let _this = this;
      this.isaddDescribe=false
      this.infoshow=true
      this.describeShow=false
      this.logicValue = [];
      this.logicValueOff=[];
      this.logicValueChoice2=[];
      this.onlogic=[]
      this.offlogic=[]
      this.choice2logic=[]
      
      console.log(obj.part.data, "点击节点");
      console.log(  this.diagram.model.vc)

      this.myHeight+=10;
      this.myWidth+=10;
      this.clickn = obj.part.data;
     
      this.stateon = this.clickn.stateon
      this.stateoff = this.clickn.stateoff
      this.infoTitle=this.clickn.title
      this.fullName=this.clickn.fullName
      this.groundValue=this.clickn.connect

      if(typeof(this.clickn.status)=="number"){
        this.currentStatus = JSON.stringify(this.clickn.status)
      }else{
        this.currentStatus = this.clickn.status
      }

      if(typeof(this.clickn.state)=="number"){
        this.state = JSON.stringify(this.clickn.state)
      }else{
        this.state = this.clickn.state
      }

      // if(!this.clickn.items&&!this.clickn.source){
      //   this.clickn.state=""
      //   this.state=""
      // }else if(this.clickn.items&&this.clickn.category.includes("抽屉")){
      //   this.clickn.state=""
      //   this.state=""
      // }

      // if(!this.clickn.zOrder){
      //   this.clickn.zOrder=0
      // }
      
      if(this.clickn.category=="切换开关"||this.clickn.category=="双头开关"||this.clickn.category=="双头开关2"||this.clickn.category=="双头开关3"){
        this.moreChoice=true
        // this.$set(this,moreChoice,true)
        // this.$forceUpdate();
        this.currentChoice1=this.clickn.option1
        this.currentChoice0=this.clickn.option0
        this.currentChoice2=this.clickn.option2
      }else{
        this.moreChoice=false
        // this.$set(this.data,moreChoice,false)
        // this.$forceUpdate();
      }
      // //console.log("323232323",this.moreChoice)
      if(this.clickn.category.includes("接地桩")&&this.clickn.status==1){
        this.isGround=true
      }else{
        this.isGround=false
      }

      if(this.type==4){//添加逻辑
          this.standardStatus=false;//是否显示标准状态
          this.titleshow = false; //标题是否可编辑
          this.operate = false;//是否显示操作
          if(this.clickn.type==1){//类型为动态元件
            this.clickDiagramnode = true;//逻辑面板
            this.isaddLogic = false; //是否显示确定按钮
          }else{
            this.clickDiagramnode = false;
            this.isaddLogic = true; 
          }
      }else if(this.type==2||this.type==3){//操作和预演
        this.clickDiagramnode = false;
        this.isaddLogic = false; 
        this.titleshow = false;
        this.standardStatus = false;
    
        if(this.clickn.type==1){
          this.operate = true;
        }else{
          this.operate = false;
          this.isaddLogic = true;
        }
      }else{//新增和修改
        this.clickDiagramnode = false;
        this.isaddLogic = false; 
        this.titleshow = true;

        if(this.clickn.type==1){
          this.standardStatus=true;
          this.operate = true;
        }else{
          this.operate = false;
          this.standardStatus = false;
        }
      }
      //查看模拟图 只让看标题
      if(this.type==6){
        this.operate = false;
        this.titleshow = false
        this.standardStatus=false
        // //console.log("看看",this.operate)
      }
      //级联数组
      //var larr=JSON.parse(JSON.stringify(this.titles))//简化版深拷贝
       var larr=Object.assign([],this.titles)//深拷贝
      //  ////console.log(larr,'larr')
      //  ////console.log(this.mapList,'mapList')
       for(var item of larr){
         for(var citem of item.children){
           for(var i=0;i<_this.mapList.length;i++){
             if(citem.value==_this.mapList[i].id){
                citem.children=_this.changeLogicarr(this.mapList[i].id)
              }
           }
         }
       }
      
      _this.infoOptions=larr
      _this.offinfoOptions=_this.infoOptions
      if(this.moreChoice){
        _this.choice2infoOptions=_this.infoOptions
      }

      // ////console.log(_this.infoOptions, "infoOptions");
      // ////console.log(_this.offinfoOptions, "offinfoOptions");
     if(!this.clickn.logicOn&&!this.clickn.items&&!this.clickn.source){
        this.clickn.logicOn=[]
      }
      if(!this.clickn.logicOff&&!this.clickn.items&&!this.clickn.source){
        this.clickn.logicOff=[]
      }
      if(!this.clickn.logicChoice2&&!this.clickn.items&&!this.clickn.source){
        this.clickn.logicChoice2=[]
      }
      if(this.clickn.category.includes("抽屉")){
        this.clickn.logicOn=[];
        this.clickn.logicOff=[]
      }
      // if(!this.usertype){

      //
      var alllogicArr=[];
      if(this.clickn.type==1){
      //开逻辑显示
      //console.log(this.clickn.logicOn,"999999")
      if(this.clickn.logicOn instanceof Array){
        this.clickn.logicOn=this.clickn.logicOn
      }else if(this.clickn.logicOn){
        this.clickn.logicOn=JSON.parse(this.clickn.logicOn)
      }
      if(this.clickn.logicOn && this.clickn.logicOn.length>0){
        var logiconMapidarr=[]
        var onsign=[]
        for (var item of this.clickn.logicOn){
            if(onsign.indexOf(item.logicSign) == -1 ) {
              onsign.push(item.logicSign)
            }
             if(logiconMapidarr.indexOf(item.mapid) == -1 ) {
                logiconMapidarr.push(item.mapid)
              }
            
        }
        alllogicArr=alllogicArr.concat(logiconMapidarr)
        this.onlogic=[]
        for(var i of onsign ){
          var b=[]
          for(var j=0;j<this.clickn.logicOn.length;j++){
            var obj={}
            if(this.clickn.logicOn[j].logicSign==i){
              obj.value=this.clickn.logicOn[j].pathLabels.join(' / ')
              obj.mapType=this.clickn.logicOn[j].pathLabels[0]
              obj.mapName=this.clickn.logicOn[j].pathLabels[1]
              obj.mapEle=this.clickn.logicOn[j].pathLabels[2]
              obj.eleStatus=this.clickn.logicOn[j].pathLabels[3]
              obj.logicSign=i
              b.push(obj)
            }
          }
          this.onlogic.push(b)
        }
      }
      
      //关逻辑显示
      //console.log(this.clickn.logicOff,"88888888")
        if(this.clickn.logicOff instanceof Array){
          this.clickn.logicOff=this.clickn.logicOff
        }else{
          // if(this.clickn.logicOff){
            this.clickn.logicOff=JSON.parse(this.clickn.logicOff)
          // }
        }
      if(this.clickn.logicOff && this.clickn.logicOff.length>0){
      
          var logicoffMapidarr=[]
          var offsign=[]
            this.clickn.logicOff.forEach((item,index)=>{
              if(offsign.indexOf(item.logicSign) == -1 ) {
                offsign.push(item.logicSign)
              }
              if(logicoffMapidarr.indexOf(item.mapid) == -1 ) {
                logicoffMapidarr.push(item.mapid)
              }
            })
         
          alllogicArr=alllogicArr.concat(logicoffMapidarr)
          //////console.log(logicoffMapidarr,'offloginmapidarr')
          this.offlogic=[]
          for(var i of offsign ){
            var b=[]
            for(var j=0;j<this.clickn.logicOff.length;j++){
              var bobj={}
              if(this.clickn.logicOff[j].logicSign==i){
                bobj.value=this.clickn.logicOff[j].pathLabels.join(' / ')
                bobj.mapType=this.clickn.logicOff[j].pathLabels[0]
                bobj.mapName=this.clickn.logicOff[j].pathLabels[1]
                bobj.mapEle=this.clickn.logicOff[j].pathLabels[2]
                bobj.eleStatus=this.clickn.logicOff[j].pathLabels[3]
                bobj.logicSign=i
                b.push(bobj)
              }
            }
            if(b.length>0){
              this.offlogic.push(b)
            }
            
          }
          
      }
      //choice2逻辑显示
       if(this.clickn.logicChoice2 instanceof Array){
            this.clickn.logicChoice2=this.clickn.logicChoice2
          }else{
            if(this.clickn.logicChoice2){
              this.clickn.logicChoice2=JSON.parse(this.clickn.logicChoice2)
            }
          }
       if(this.clickn.logicChoice2 && this.clickn.logicChoice2.length>0){
         
         
          var logicchoice2Mapidarr=[]
          var choicesign=[]
          for (var item of this.clickn.logicChoice2){
              if(choicesign.indexOf(item.logicSign) == -1 ) {
                choicesign.push(item.logicSign)
              }
               if(logicchoice2Mapidarr.indexOf(item.mapid) == -1 ) {
                logicchoice2Mapidarr.push(item.mapid)
              }
          }
          alllogicArr=alllogicArr.concat(logicchoice2Mapidarr)
          this.choice2logic=[]
          for(var i of choicesign ){
            var b=[]
            for(var j=0;j<this.clickn.logicChoice2.length;j++){
              var bobj={}
              if(this.clickn.logicChoice2[j].logicSign==i){
                bobj.value=this.clickn.logicChoice2[j].pathLabels.join(' / ')
                bobj.mapType=this.clickn.logicChoice2[j].pathLabels[0]
                bobj.mapName=this.clickn.logicChoice2[j].pathLabels[1]
                bobj.mapEle=this.clickn.logicChoice2[j].pathLabels[2]
                bobj.eleStatus=this.clickn.logicChoice2[j].pathLabels[3]
                bobj.logicSign=i
                b.push(bobj)
              }
            }
            this.choice2logic.push(b)
          }
          
      }
      var maplogicArr=[]
      for(var item of alllogicArr){
        if(maplogicArr.indexOf(item)==-1){
          maplogicArr.push(item)
        }
      }
      this.getmapidsInfo(maplogicArr.join(','))
      }
    },
  
    //合并随意行数的功能
    getSpanArr(data) {
      var spanArr = [];
      var pos=0
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          spanArr.push(1);
          pos=0
        } else {
          if (data[i].logicSign === data[i - 1].logicSign) {
            // 如果logicSign相等就累加，并且push 0  这里是根据一样的logicSign匹配
            spanArr[pos] += 1;
            spanArr.push(0);
          } else {
            spanArr.push(1);
            pos = i;
          }
        }
      }
      return spanArr
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      var spanArr=this.getSpanArr(this.operRecord)
     // columnIndex === 0 找到第一列，实现合并随机出现的行数
      if (columnIndex === 0) {
        var _row = spanArr[rowIndex];
        var _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      };
      // if (rowIndex === 0) {
      //     if (columnIndex === 8) { //这两个判断是定位到要合并的那个单元格
      //     var listVal = this.assessJson.length; //最后总分合并所有行
      //       return {
      //         rowspan: listVal, //合并几行 原本的多行变为单行
      //         colspan: 1 //合并几列
      //       };
      //     }
      //   }
      },

    //删除节点后 删除本图对应所有逻辑
    deleteNode(e){
      // //console.log("删除啦",e)
        let _this=this
        this.infoshow=false
        if(this.clickn.id){
          this.$api.delcomponentlist({id:this.clickn.id},res=>{
            if(res.errCode==0){
              this.$message({
                message: "删除成功",
                type: "success"
              });
            }
          })
        }
        //新增的时候删除节点不需要调接口
        // //console.log(this.type)
        if(this.type){
          this.$api.getcomponentlist({pagesize:9999},res=>{
            res.data.list.forEach(item=>{
              if(item.logicOn&&JSON.parse(item.logicOn).length>0){
                    var arr = JSON.parse(item.logicOn).filter((v)=>{
                      return v.key!=this.clickn.id
                    })
                  
                    item.logicOn=JSON.stringify(arr)
                    _this.$api.changecom({nodedata:item},res=>{
              
                    })
              }
  
              if(item.logicOff&&JSON.parse(item.logicOff).length>0){
                    var a = JSON.parse(item.logicOff).filter((v)=>{
                      return v.key!=this.clickn.id
                    })
                  
                    item.logicOff=JSON.stringify(a)
                    _this.$api.changecom({nodedata:item},res=>{
              
                    })
              }
  
              if(item.logicChoice2&&JSON.parse(item.logicChoice2).length>0){
                    var carr = JSON.parse(item.logicChoice2).filter((v)=>{
                      return v.key!=this.clickn.id
                    })
                  
                    item.logicChoice2=JSON.stringify(carr)
                    _this.$api.changecom({nodedata:item},res=>{
              
                    })
              }
              
            })
          })
        }
        
    },
    loop() {
      var _this = this;
      setTimeout(function() {
        _this.updateStates();
        _this.loop();
      }, 250);
    },
    nodeStyle() {
      let _this =this;
      if(this.type!==4){
        var contextmenu= $("ContextMenu",
            $("ContextMenuButton",
              $(go.TextBlock, "添加描述"),
              { click: function(e, obj) { _this.addDescribe(1,obj) }  }),
            $("ContextMenuButton",
              $(go.TextBlock, "查看描述"),
              { click: function(e, obj) { _this.addDescribe(2,obj) }  }),
            $("ContextMenuButton",
              $(go.TextBlock, "降一层级"),
              { click: function(e, obj) { _this.changeZOrder(-1, obj); } }),
            $("ContextMenuButton",
              $(go.TextBlock, "升一层级"),
              { click: function(e, obj) { _this.changeZOrder(1, obj); } })
          )
      }else{
        contextmenu=null
      }
      var sharedToolTip = $(
        "ToolTip",
        { "Border.figure": "RoundedRectangle" },
        $(
          go.TextBlock,
          { margin: 2 },
          new go.Binding("text", "", function(d) {
            return d.category;
          })
        )
      );
      return [
        //临时将选定的节点放在前景层
        //new go.Binding("layerName", "isSelected", function(s) { return s ? "Foreground" : ""; }).ofObject(),
        //new go.Binding("layerName").makeTwoWay(),
        new go.Binding("location", "loc", go.Point.parse).makeTwoWay(
          go.Point.stringify
        ),
        new go.Binding("isShadowed", "isSelected").ofObject(),
        {
          locationSpot: go.Spot.LeftCenter,
          selectionAdorned: false,
          shadowOffset: new go.Point(0, 0),
          shadowBlur: 15,
          shadowColor: "blue",
          toolTip: sharedToolTip,
          // resizable: true,
          // resizeObjectName: "SHAPE", // 拉伸图形
          rotatable: true,
          rotateObjectName: "SHAPE", // user can rotate the Shape
          mouseEnter: (e, obj) => {
            if(_this.type!==2&&_this.type!==3&&_this.type!==4){
              this.showPorts(obj.part, true);
            }
          },
          mouseLeave: (e, obj) => {
             if(_this.type!==2&&_this.type!==3&&_this.type!==4){
              this.showPorts(obj.part, false);
             }
          },
          click: this.clickNode,
  
          contextMenu: contextmenu   
         
           
        }
      ];
    },
    //展示port
    showPorts(node, show) {
      let diagram = node.diagram;
      if (!diagram || diagram.isReadOnly || !diagram.allowLink) return;
      node.ports.each(function(port) {
        port.stroke = show ? "white" : null;
      });
    },
    //修改层级
    changeZOrder(amt, obj) {
      this.diagram.commit(function(d) {
        var data = obj.part.data;
        d.model.set(data, "zOrder", data.zOrder + amt);
      }, 'modified zOrder');
    },
    //线的样式
    shapeStyle() {
      var _this = this;
      return {
        //name: "SHAPE",
        fill: "lightgray",
        stroke: "#000000",
        desiredSize: new go.Size(40, 40),
        strokeWidth: 1
      };
    },
    shapeStyle2() {
      return {
        //name: "SHAPE",
        fill: "lightgray",
        stroke: "#000000",
        desiredSize: new go.Size(40, 40),
        strokeWidth: 1
      };
    },
    //图片样式
    imgStyle() {
      return {
        //name: "SHAPE",
        // desiredSize: new go.Size(40, 40),
        // source:this.png2
        //source: require("../assets/2.png"),
        //width: 50
      };
    },
    //port口样式
    portStyle(spot, input, output) {
      return {
        desiredSize: new go.Size(7, 7),
        fill: "transparent",
        stroke: null,
        alignment: spot, // align the port on the main Shape
        alignmentFocus: spot, // just inside the Shape
        fromSpot: spot,
        fromLinkable: output,
        toSpot: spot,
        toLinkable: input,
        //toMaxLinks: 1,//一个口能接受多少线
        cursor: "pointer"
      };
    },
    makePort(name, spot, output, input) {
        // the port is basically just a small transparent square
        return $(go.Shape, "Circle",
          {
            fill: null,  // not seen, by default; set to a translucent gray by showSmallPorts, defined below
            stroke: null,
            desiredSize: new go.Size(7, 7),
            alignment: spot,  // align the port on the main Shape
            alignmentFocus: spot,  // just inside the Shape
            portId: name,  // declare this object to be a "port"
            fromSpot: spot, toSpot: spot,  // declare where links may connect at this port
            fromLinkable: output, toLinkable: input,  // declare whether the user may draw links to/from here
            cursor: "pointer"  // show a different cursor to indicate potential link point
          });
      },
    changeStyle(key, fill) {
      var _this = this;
      var node = this.diagram.model.findNodeDataForKey(key); //首先拿到这个节点的对象
      if (fill == _this.color) {
        this.diagram.model.setDataProperty(node, "fill", _this.offcolor); //然后对这个对象的属性进行更改
        this.diagram.model.setDataProperty(node, "status", 0); 
        //this.state="0"
      } else if (fill == _this.offcolor) {
        this.diagram.model.setDataProperty(node, "fill", _this.color);
        this.diagram.model.setDataProperty(node, "status", 1); 
        //this.state="1"
      }
    },
    changeStroke(key, stroke) {
      var _this = this;
      var node = this.diagram.model.findNodeDataForKey(key); //首先拿到这个节点的对象
    
      if (stroke == _this.color) {
        this.diagram.model.setDataProperty(node, "stroke", _this.offcolor); //然后对这个对象的属性进行更改
        this.diagram.model.setDataProperty(node, "status", 0); 
      } else if (stroke == _this.offcolor) {
        this.diagram.model.setDataProperty(node, "stroke", _this.color);
        this.diagram.model.setDataProperty(node, "status", 1); 
      }
    },
    changeCategory(key, category) {
      var _this = this;
      var node = this.diagram.model.findNodeDataForKey(key); //首先拿到这个节点的对象
    
      if (category == "抽屉") {
        this.diagram.model.setDataProperty(node, "category", "抽屉2"); //然后对这个对象的属性进行更改
      } else  {
        this.diagram.model.setDataProperty(node, "category", "抽屉");
      }

      if(category == "双头开关"){
        this.diagram.model.setDataProperty(node, "category", "双头开关2");
        this.diagram.model.setDataProperty(node, "status", 0);
      }if(category == "双头开关2"){
        this.diagram.model.setDataProperty(node, "category", "双头开关3");
        this.diagram.model.setDataProperty(node, "status", 2);
      }if(category == "双头开关3"){
        this.diagram.model.setDataProperty(node, "category", "双头开关");
        this.diagram.model.setDataProperty(node, "status", 1);
      }
    },
    changeDraw(key,category){
      let _this=this
      var drawItems=[{ height:110,width:40,source:_this.png33 }]
      var draw2Items=[{ height:100, width:40, source:_this.png34 }]
       var node = this.diagram.model.findNodeDataForKey(key); //首先拿到这个节点的对象
       if(category=="抽屉"){
        _this.diagram.model.setDataProperty(node, "items", draw2Items); 
        _this.diagram.model.setDataProperty(node, "category", "抽屉2"); 
        _this.diagram.model.setDataProperty(node, "status", 0); 
        //_this.changeCategory(data.key,data.category)
      }else if(category=="抽屉2"){
        _this.diagram.model.setDataProperty(node, "items", drawItems); 
        _this.diagram.model.setDataProperty(node, "category", "抽屉"); 
        _this.diagram.model.setDataProperty(node, "status", 1); 
        
      }
    },
    changeAngle(key, angle) {
      var _this = this;
      var node = this.diagram.model.findNodeDataForKey(key); //首先拿到这个节点的对象
      if (angle == 0&&node.category=="闸刀2") {
        this.diagram.model.setDataProperty(node, "angle", 90); 
        this.diagram.model.setDataProperty(node, "category", "闸刀"); 
      }if (angle == 90&&node.category=="闸刀") {
        this.diagram.model.setDataProperty(node, "angle", 0);
        this.diagram.model.setDataProperty(node, "category", "闸刀2"); 
      }
      if (angle == 300&&node.category=="切换开关") {
        this.diagram.model.setDataProperty(node, "angle", 0); //然后对这个对象的属性进行更改
        this.diagram.model.setDataProperty(node, "status", 0);
      }else if (angle == 0&&node.category=="切换开关") {
        this.diagram.model.setDataProperty(node, "angle", 60);
        this.diagram.model.setDataProperty(node, "status", 2);
      }else if (angle == 60&&node.category=="切换开关") {
        this.diagram.model.setDataProperty(node, "angle", 300);
        this.diagram.model.setDataProperty(node, "status", 1);
        
      }
    },
    updateStates(key) {
      var _this = this;
      var oldskip = _this.diagram.skipsUndoManager;
      _this.diagram.skipsUndoManager = true;
      // //连接线随着点击改变
      // _this.diagram.nodes.each(function(node) {
      //     if (node.category === "oilGrove") {
      //         _this.doInput(node);
      //     }
      // });

      // // //相关联的随着点击改变
      _this.diagram.nodes.each(function(node) {
        if (node.data.parent == key) {
          _this.changeStyle(node.data.key, node.data.fill);
        }
      });
      _this.diagram.skipsUndoManager = oldskip;
    },
    doInput(node) {
      var _this = this;
      // the output is just the node's Shape.fill
      _this.setOutputLinks(node, node.findObject("NODESHAPE").fill);
    },
   
    // helper function for propagating results
    setOutputLinks(node, color) {
      node.findLinksOutOf().each(function(link) {
        link.findObject("SHAPE").stroke = color;
      });
    },
    handleChange(val) {
      this.activeName=val
    },
    collapse(val){
      if(val==1){
        this.item1=true
        this.item2=false
        this.item3=false
      } if(val==2){
        this.item2=true
        this.item1=false
        this.item3=false
      }if(val==3){
        this.item3=true
        this.item2=false
        this.item1=false
      }
    },
    logicSignformat(row){
      return row.logicSign+1
    },
    tableRowClassName({row, rowIndex}) {
      for(var item of this.wrongIndex)
        if (rowIndex == item) {
          return 'warning-row';
        } 
        return '';
      },
    handleAvatarSuccess(res, file) {
      this.hideUpload = true;
    },
    handleRemove(file, fileList) {
      this.hideUpload = false;
      //////console.log(file,fileList)
      this.rightclick.url = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeAvatarUpload(file) {
      let types = ["image/jpeg", "image/png"];
      const isImage = types.includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 30;
      if (!isImage) {
        this.$message.error("只能上传 JPG 或 PNG 文件!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 30MB!");
      }
      return isImage && isLt2M;
    },
    //上传
    fileupload(el) {
      this.hideUpload = true;
      var formdata = new FormData();
      formdata.append("file", el.file);
  
      var oReq = new XMLHttpRequest();
      //  this.$api.fileupload(formdata, res => {
      //   if (res.errcode == 0) {
      //     var fileinfo = res.data;
      //     _this.fileList = res;
      //     _this.previewimgurl = res.url;
      //   } else {
      //     _this.$message.error({
      //       message: "上传失败，请重试"
      //     });
          
      //   }
         
      //   });
      oReq.open("POST", "/map/fileupload", true);
      oReq.setRequestHeader("Authorization", localStorage.getItem("token"));
      oReq.send(formdata);
      let _this = this;
      oReq.onload = function(oEvent) {
        if (oReq.status == 200) {
          var fileinfo = JSON.parse(oReq.response).data;
          if (JSON.parse(oReq.response).errcode == 0) {
            var obj={}
            obj.name=JSON.parse(oReq.response).data.name
            obj.url=JSON.parse(oReq.response).url

            _this.fileList.push(obj);
            //////console.log(_this.fileList,'fffffff')
            _this.rightclick.url=_this.fileList
            //////console.log(_this.rightclick,'rrrrrrrrrrrrrrr')
            var nparams=JSON.parse(JSON.stringify(_this.rightclick))
            if(nparams.logicOn instanceof Array){
              nparams.logicOn=JSON.stringify(nparams.logicOn)
            }
            if(nparams.logicOff instanceof Array){
              nparams.logicOff=JSON.stringify(nparams.logicOff)
            }
            if(nparams.logicChoice2 instanceof Array){
              nparams.logicChoice2=JSON.stringify(nparams.logicChoice2)
            }
            if(nparams.url instanceof Array){
              nparams.url=JSON.stringify(nparams.url)
            }
            let params={
              nodedata:nparams
            }
             _this.$api.changecom(params,res=>{
                if (res.errCode == 0) {
                  // this.$message({
                  //   message: "操作成功",
                  //   type: "success"
                  // });
                }
            })
            
          } else {
            _this.$message.error({
              message: "上传失败，请重试"
            });
            this.fileinfo = {};
          }
        } else {
          _this.$message.error({
            message: "上传失败，请重试"
          });
          this.fileinfo = {};
        }
       };
    },
  }
};
</script>
<style scoped>
.setImgAttr{
  display: flex;
  flex-direction: column;
}
.setImgAttr>div{
  display: flex;
  /* margin-bottom: 4px; */
  margin-top: 8px;
}
.imgTitle{
  width: 70px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
}
.el-table /deep/ .warning-row {
    color: red;
  }
.map {
  width: 95%;
  height:100%;
  white-space: nowrap;
  margin: auto;
}
.palettedraggable{
  height:calc(100% - 50px);
  width:300px;
  /* margin-top:10px; */
  display: inline-block;
  border: 2px solid #bbb;
  border-radius: 5px;
  background-color: #f5f5f5;
}
.diagram{
  height: calc(100% - 80px);
  /* height: 85vh; */
  display:inline-block; 
  /* margin-top:10px; */
  /* background:#f5f5f5; */
  background-color: #fff;
  vertical-align: top;
  position:relative;
  border: 2px solid #bbb;
  border-radius: 5px;
}
.draggable {
  /* display: inline-block;
  vertical-align: top; */
  border: 2px solid #bbb;
  border-radius: 5px;
  /* background-color: #f5f5f5; */
  background-color: #fff;
  position: absolute;
  /* top: 375px;
  left: 60px; */
  z-index: 500;
}

.handle {
  height:20px;
  background-color: lightblue;
  cursor: move;
  text-align: center;
  font: bold 14px sans-serif;
}
#infoDraggable {
  font: 12px helvetica, sans-serif;
  min-width: 213px;
  max-width:500px;
  /* overflow: auto; */
}
.imgupload{
  max-width:500px;
  white-space: normal;
}

#infoDraggable  /deep/ .el-select{
  /* width:220px; */
  width:calc(100% - 80px);
}
.titleStyle /deep/ .el-textarea__inner{
   width:calc(100% - 80px);
}
.el-cascader{
  width:calc(100% - 80px);
}
#myInfo {
  width: 100%;
  overflow: hidden;
  /* text-align: left; */
}

#myPaletteDiv,#myPaletteDiv1 {
  /* background-color: #f5f5f5; */
  background-color: #fff;
  width: 100%;
  
}
#paletteContainer {
  /* position: absolute;
    bottom: 14px;
    left: 0px;
    right: 0px;
    top: 14px; */
  height: 280px;
}
/* .map /deep/ .el-dialog__header {
  text-align: left;
} */
.map /deep/ .el-dialog__body .el-input {
  width: 350px;
}
.map /deep/ .el-dialog__body{
  white-space: normal;
}
.ui-accordion .ui-accordion-header{
    display: block;
    cursor: pointer;
    position: relative;
    margin: 2px 0 0 0;
    padding: .5em .5em .5em .7em;
    font-size: 100%;
}
.ui-state-active{
    border: 1px solid #003eff;
    background: #007fff;
    font-weight: normal;
    color: #f5f5f5;
}
[class^=el-icon-]{
   vertical-align: middle;
}
ul {
  margin:0px;
}
li{
  text-align:left
}
.showlogic{
  width:calc(100% - 10px);
  margin:auto;
  /* padding:0 5px; */
  min-height:100px;
  max-height:380px;
  overflow-y: auto;
  border:1px solid #C0C4CC;
  border-radius:5px;
  background:#fff;
  text-align:left;
  word-wrap: break-word;
  word-break: break-all;
}
.buttonGroup{
  margin-left: 50px;
  
}
.head-select{
  display: flex;
  margin-left: 50px;
  margin-right: 50px;
  /* justify-content: center; */
}
.mapHead .el-cascader{
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.head-select /deep/ input{
  height: 37px;
}
#myInfo /deep/ input{
  -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
}
.el-tag{
  display:block;
  height:100%;
  margin: 5px auto;
  /* max-width:250px; */
  width:85%;
  word-break: break-all;
  white-space: normal;
}

.logicLabel{
  display:inline-block;
  font-size:14px;
  min-width:70px;
  text-align:center;
}
.raidoInput /deep/ .el-input{
  border:none;
  max-width:100px;
  line-height:1;
}
.raidoInput /deep/ .el-radio{
  margin-right:10px;
}
.mapHead{
  line-height: 50px;
  /* background-color: #0b5288; */
  display: flex;
  justify-content: center;
}
.addMapClass /deep/ .el-input{
  width: 250px;
}
.addMapClass /deep/ .el-form-item {
  display: flex;
}
.addMapClass /deep/ .el-form-item__content {
  margin-left: 10px !important;
}
.promptBtn{
  padding: 10px;
  /* display: flex;
  justify-content: flex-end; */
}
.myprompt /deep/ .el-dialog__body{
  padding-top: 5px;
}
.describle{
  margin:8px 0;
}
.describle /deep/ .el-textarea{
  width:calc(100% - 80px);
  vertical-align: middle;
}
.imgupload /deep/ .el-upload-list--picture-card .el-upload-list__item{
  width:110px;
  height:110px;
  transition:none;
}

.imgupload /deep/ .el-upload--picture-card{
  width:110px;
  height:110px;
  line-height:110px;
}
.map{
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/makeMap.vue